<template>
  <div>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap">
      <div
        class="left"
        :style="{ width: isMac ? 'calc(100% - 266px)' : 'calc(100% - 251px)' }"
      >
        <el-form
          ref="scheduleForm"
          class="demo-ruleForm"
          label-position="left"
          label-width="120px"
          hide-required-asterisk
          :model="scheduleForm"
          :rules="rules"
        >
          <ContentBox title="所属项目订单" id="订单设置" class="content-box">
            <el-row>
              <el-col>
                <el-form-item label="订单名称">
                  <CommonLazySelect
                    v-if="mode === 'edit' && scheduleForm.scheduleStatus === 1"
                    v-model="scheduleForm.orderId"
                    class="lazy-select"
                    serviceName="getOrderList"
                    :filter="{
                      orderName: '',
                      sellingType: scheduleForm.billType,
                      partnerId: scheduleForm.partnerId
                    }"
                    :primaryKey="{ orderId: scheduleForm.orderId }"
                    :optionsMap="{
                      key: 'orderId',
                      label: 'orderName'
                    }"
                    :clearable="false"
                    :extendField="true"
                    @selected="handleChangeOrder"
                  />
                  <div v-else>{{ order.orderName || '-' }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </ContentBox>
          <ContentBox v-if="erpModeSwitch === 1" title="关联ERP订单" class="content-box">
            <el-row>
              <el-form-item style="margin: 12px 0" label="选择ERP订单">
                <ErpOrderSelecter
                  :subOrder="scheduleForm.erpSubOrder"
                  :erpOrderName="scheduleForm.erpOrderName"
                  :disabled="mode !== 'create' && scheduleForm.scheduleStatus !== 1"
                  :selling-type="order.sellingType"
                  :space-list="directinal.spaceList"
                  @data-select="handleSelectErpOrder"
                  @clear="clearErpOrder"
                />
              </el-form-item>
            </el-row>
          </ContentBox>
          <ContentBox
            v-if="erpModeSwitch === 2"
            title="关联销售子订单"
            class="content-box"
          >
            <el-row>
              <el-form-item style="margin: 12px 0" label="选择子订单">
                <el-select
                  v-show="spaceList.length"
                  v-model="scheduleForm.suborderNo"
                  filterable
                  clearable
                  class="form-select"
                  no-data-text="请前往SSP订单下创建子订单"
                  :disabled="mode !== 'create' && scheduleForm.scheduleStatus !== 1"
                  @change="handleChangeSubOrder"
                >
                  <el-option
                    v-for="item in subOrderOptions"
                    :key="item.suborderId"
                    :label="`${item.suborderName} (${item.suborderNo})`"
                    :value="item.suborderNo"
                  >
                    {{ item.suborderName }}
                    <span class="popper-option__tail">({{ item.suborderNo }})</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </ContentBox>
          <ContentBox title="基础设置" id="基础设置" class="content-box">
            <el-row>
              <el-col>
                <el-form-item label="计划类型">
                  <el-radio-group
                    v-model="scheduleForm.planType"
                    :disabled="disableForm.planTypeDisabled"
                    @change="handleChangePlanType"
                  >
                    <el-radio-button
                      v-for="(item, index) in planTypeList"
                      :key="index"
                      :label="item.value"
                      >{{ item.label }}</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="scheduleForm.planType === 1">
              <el-col>
                <el-form-item label="程序化来源" prop="scheduleSource">
                  <template v-for="(item, index) in scheduleSourceList">
                    <el-radio
                      :value="scheduleForm.scheduleSource"
                      :label="item.value"
                      :disabled="disableForm.scheduleSourceDisabled"
                      :key="'s' + index"
                      @input="handleChangeScheduleSource"
                      >{{ item.label }}</el-radio
                    >
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-show="
                scheduleForm.planType === 1 &&
                (scheduleForm.scheduleSource || scheduleForm.scheduleSource === 0)
              "
            >
              <el-col>
                <el-form-item label="程序化类型">
                  <el-radio-group
                    v-model="scheduleForm.supportMode"
                    :disabled="disableForm.showSupportModeDisabled"
                    @input="handleChangeSupportMode"
                  >
                    <el-radio-button v-if="showSupportMode.pdb" :label="0"
                      >保价保量(PDB)</el-radio-button
                    >
                    <el-radio-button v-if="showSupportMode.pd" :label="1"
                      >保价不保量(PD)</el-radio-button
                    >
                    <el-radio-button v-if="showSupportMode.cpdb" :label="2"
                      >保价全量(CPDB)</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="销售方式">
                  <el-radio-group
                    v-model="scheduleForm.saleType"
                    :disabled="disableForm.saleTypeDisabled"
                  >
                    <el-radio-button
                      v-for="(item, index) in saleTypeOptions"
                      :key="index"
                      :label="item.value"
                      >{{ item.label }}</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="投放渠道" v-if="channelIdList.length > 0">
                  <el-radio-group
                    v-model="scheduleForm.channelId"
                    @change="handleChangeChannel"
                    :disabled="disableForm.channelDisabled"
                  >
                    <el-radio-button
                      v-for="(item, index) in channelIdList"
                      :key="'c' + index"
                      :label="item.value"
                      >{{ item.label }}</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="结算方式" v-if="paymentList.length > 0">
                  <el-select
                    class="form-select"
                    v-model="scheduleForm.payment"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in paymentOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="优先级">
                  <div class="flex-form-item">
                    <el-radio-group
                      v-model="scheduleForm.seqType"
                      @change="handleChangeSeq"
                    >
                      <el-radio-button :label="0">自动设置</el-radio-button>
                      <el-radio-button :label="1">手动设置</el-radio-button>
                    </el-radio-group>
                    <template v-if="scheduleForm.seqType === 1">
                      <el-select
                        class="form-item-select"
                        v-model="scheduleForm.seq"
                        filterable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in seqList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="广告位" prop="spaceId">
                  <el-select
                    filterable
                    class="form-select"
                    placeholder="请选择"
                    :value="scheduleForm.spaceId"
                    :disabled="disableForm.spaceDisabled"
                    @input="handleInputChangeSpace"
                  >
                    <el-option
                      v-for="item in spaceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="投放速度">
                  <el-radio-group
                    v-model="scheduleForm.trafficSpeed"
                    @change="handleTrafficSpeedChange"
                  >
                    <el-radio-button :label="2">匀速</el-radio-button>
                    <el-radio-button :label="1" v-if="isOwn">快速</el-radio-button>
                    <el-radio-button :label="3" v-if="isOwn">智能</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item
                  label="TA浓度"
                  v-if="
                    scheduleForm.trafficSpeed === 2 || scheduleForm.trafficSpeed === 3
                  "
                >
                  <div class="flex-form-item">
                    <el-radio-group
                      v-model="pvRateType"
                      @change="scheduleForm.pvRate = ''"
                    >
                      <el-radio-button :label="0">无</el-radio-button>
                      <el-radio-button :label="1">按TA</el-radio-button>
                    </el-radio-group>
                    <template v-if="pvRateType === 1">
                      <el-select
                        class="form-item-select"
                        v-model="scheduleForm.pvRate"
                        filterable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in pvRateOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="考核指标" prop="uvCanSelect">
                  <el-checkbox-group
                    v-model="scheduleTaUvKpi"
                    @change="handleKpiCable"
                    :disabled="isHasNewSystem"
                  >
                    <el-checkbox-button :label="0">无</el-checkbox-button>
                    <el-checkbox-button
                      v-for="item in kpiList"
                      :label="item.key"
                      :key="item.key"
                      >{{ item.label }}</el-checkbox-button
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="scheduleTaUvKpi.includes('N+UV')" class="nuv-wrap">
              <el-col class="col1">
                <el-form-item label="N+UV指标" prop="uvTarget">
                  <template slot="label">
                    <span>
                      N+UV指标
                      <el-tooltip class="item" effect="light" placement="top-start">
                        <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                        <div slot="content">
                          N+UV指标配置后，系统会自动同步DMP，建单后10分钟内计算完成并关联人群包
                        </div>
                      </el-tooltip>
                    </span>
                  </template>
                  <el-input
                    type="number"
                    v-model.number="scheduleForm.uvTarget"
                    @input="uvInputHandle"
                    style="width: 150px"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="col2">
                <el-form-item label label-width="1px">+UV 大于</el-form-item>
              </el-col>
              <el-col class="col3">
                <el-form-item label label-width="1px" prop="uvPercentage">
                  <el-input
                    type="number"
                    v-model="scheduleForm.uvPercentage"
                    style="width: 150px"
                    maxlength="6"
                  ></el-input
                  >%
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="scheduleTaUvKpi.includes('N+UV')" class="nuv-wrap">
              <el-col>
                <el-form-item label="曝光频次占比" prop="pvRatioType">
                  <template slot="label">
                    <span>
                      曝光频次占比
                      <el-tooltip class="item" effect="light" placement="top-start">
                        <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                        <div slot="content">只有N+UV考核的单才可配置此内容</div>
                      </el-tooltip>
                    </span>
                  </template>
                  <el-radio-group
                    v-model="scheduleForm.pvRatioType"
                    @change="handleChangePvRatioType"
                  >
                    <el-radio-button :label="0">
                      默认
                      <el-tooltip effect="light" placement="top-start">
                        <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                        <div slot="content">
                          <div>例：计划单整单控5次，考核4+大于60%</div>
                          <div>
                            默认：曝光4、5的所需设备均分后分别占比30%；3、2、1用剩下的40%均分后，所需设备分别为13.33%、13.33%、13.34%
                          </div>
                        </div>
                      </el-tooltip>
                    </el-radio-button>
                    <el-radio-button :label="1">
                      自定义
                      <el-tooltip effect="light" placement="top-start">
                        <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                        <div slot="content">
                          自定义配置各频次占比，未配置的频次，占比按百分比-配置的执行
                        </div>
                      </el-tooltip>
                    </el-radio-button>
                  </el-radio-group>
                  <el-form-item v-if="scheduleForm.pvRatioType !== 0">
                    <div class="ratiolist-wrapper">
                      <PvFrequency
                        v-model="scheduleForm.uvRateList"
                        ref="PvFrequency"
                        :scheduleForm="scheduleForm"
                        @change="pvFrequencyChange"
                      ></PvFrequency>
                    </div>
                  </el-form-item>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="scheduleTaUvKpi.includes('TA')">
              <el-col>
                <el-form-item label="TA考核" prop="taCondition">
                  <el-input
                    @input="clearSpaceHandle"
                    placeholder="输入TA考核条件"
                    maxlength="50"
                    show-word-limit
                    clearable
                    v-model="scheduleForm.taCondition"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="showExposureDirectly">
              <el-col>
                <el-form-item>
                  <label slot="label">
                    计划强植入
                    <el-tooltip class="item" effect="light" placement="top-start">
                      <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                      <div slot="content">
                        仅适用于开启实时行为兴趣推荐的广告位，启用后，将不再使用标签匹配规则，在发起合适广告请求时直接展示当前广告。
                      </div>
                    </el-tooltip>
                  </label>
                  <el-radio-group v-model="scheduleForm.exposureDirectly">
                    <el-radio-button :label="1">不启用</el-radio-button>
                    <el-radio-button :label="0">启用</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="扩展参数">
                  <el-radio-group
                    v-model="extendParamType"
                    @change="handleChangeExtendType"
                  >
                    <el-radio-button :label="0">无</el-radio-button>
                    <el-radio-button :label="1">配置</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="模板名称" v-if="extendParamType === 1">
                  <el-select
                    class="form-select"
                    :value="template"
                    placeholder="请选择模板"
                    @input="handleInputChangeTemplate"
                  >
                    <el-option label="自定义" value="none"></el-option>
                    <el-option
                      v-for="item in templateList"
                      :key="item.templateId"
                      :label="item.templateName"
                      :value="item.templateId"
                    ></el-option>
                  </el-select>
                  <ExtendParam
                    style="padding-top: 20px"
                    ref="extendParam"
                    :template="template"
                    v-model="extendParamList"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="scheduleForm.planType === 1">
              <el-col>
                <el-form-item label="dealID" prop="dealId">
                  <div class="flex-form-item">
                    <el-radio-group v-model="dealIdType" @change="handleDealIdTypeChange">
                      <el-radio-button :label="0">计划单号</el-radio-button>
                      <el-radio-button :label="1">自定义</el-radio-button>
                    </el-radio-group>
                    <template v-if="dealIdType === 1">
                      <el-input
                        v-model="scheduleForm.dealId"
                        style="margin-left: 20px; width: 260px"
                      ></el-input>
                    </template>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="showCtr">
              <el-col>
                <div class="flex-form-panel">
                  <el-form-item label="CTR权重">
                    <el-radio-group
                      v-model="ctrType"
                      @change="scheduleForm.ctr = undefined"
                    >
                      <el-radio-button :label="0">不加权</el-radio-button>
                      <el-radio-button :label="1">配置</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <template v-if="ctrType === 1">
                    <el-form-item label-width="0" prop="ctr">
                      <el-input
                        class="flex-form-content"
                        v-model="scheduleForm.ctr"
                        placeholder="1~1000的整数"
                      ></el-input
                      >&nbsp;‰
                    </el-form-item>
                  </template>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item>
                  <template #label>
                    IES服务
                    <el-tooltip class="item" effect="light" placement="top-start">
                      <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                      <div slot="content">
                        IES开启，计划审核完成后会自动替换IES宏参，并自动获取秒针的监测数据与自有监测数据对比、自动发起预警；
                        关闭后则无法获取秒针监测数据、无法发起自动预警；
                      </div>
                    </el-tooltip>
                  </template>
                  <el-switch
                    v-model="scheduleForm.iesSwitch"
                    :active-value="1"
                    :inactive-value="0"
                  ></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </ContentBox>
          <ContentBox class="content-box" title="投放设置" id="投放设置">
            <el-row>
              <el-col>
                <el-form-item label="媒体方" prop="cableChannelList">
                  <CheckBoxGroup
                    v-model="scheduleForm.cableChannelList"
                    :options="cableChannelList"
                    :disabled="disableForm.cableChannel"
                    @input="handleCheckedCable"
                  ></CheckBoxGroup>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="投放时间" prop="dateType">
                  <div class="flex-form-item">
                    <el-radio-group
                      v-model="scheduleForm.dateType"
                      @change="handleChangeDateType"
                    >
                      <el-radio-button :label="0">全天</el-radio-button>
                      <el-radio-button :label="1">指定时段</el-radio-button>
                    </el-radio-group>
                    <span
                      v-if="!isOwn && scheduleForm.dateType === 1"
                      style="color: #ff8b00"
                      >&nbsp;&nbsp;投放新系统时，结束时间请选择xx:59:59</span
                    >
                  </div>
                  <!-- <el-form :model="scheduleForm" ref="scheduleForm"> -->
                  <el-form-item
                    v-for="(putTimeList, index) in scheduleForm.putTimeList"
                    :key="'t' + index"
                    :prop="'putTimeList.' + index + '.timeDay'"
                    :rules="putTimeListRules.timeDay"
                  >
                    <div class="flex-form-item">
                      <el-date-picker
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        class="c-date-picker"
                        :value="putTimeList.timeDay"
                        :picker-options="putTimeList.pickerOptions"
                        :disabled="putTimeList.disabled"
                        @focus="pickingIndex = index"
                        @input="handleInputPutTime(index, $event)"
                      ></el-date-picker>
                      <el-time-picker
                        v-if="scheduleForm.dateType === 1"
                        v-model="putTimeList.timeHours"
                        is-range
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围"
                        class="c-date-picker"
                        value-format="HH:mm:ss"
                        :disabled="putTimeList.disabled"
                      ></el-time-picker>
                      <div style="margin-top: 24px">
                        <el-button
                          v-if="scheduleForm.putTimeList.length > 1"
                          :disabled="putTimeList.disabled"
                          @click="handleDeleteTimePicker(index)"
                          >删除</el-button
                        >
                        <el-button
                          v-if="index >= scheduleForm.putTimeList.length - 1"
                          @click="handleAddTimePicker('scheduleForm')"
                          >增加</el-button
                        >
                      </div>
                    </div>
                  </el-form-item>
                  <!-- </el-form> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="投放总量" prop="totalTraffic">
                  <el-input
                    v-model="scheduleForm.totalTraffic"
                    placeholder="请输入投放总量"
                    :class="
                      disableForm.trafficTypeDisabled
                        ? 'input-with-select--diabled'
                        : 'input-with-select'
                    "
                    :disabled="
                      scheduleForm.trafficType === 1 ||
                      (disableForm.trafficTypeDisabled && scheduleForm.trafficType === 4)
                    "
                    @change="handleChangeTotalTraffic"
                  >
                    <el-select
                      v-model="scheduleForm.trafficType"
                      slot="prepend"
                      placeholder="请选择"
                      :disabled="disableForm.trafficTypeDisabled"
                      @change="handleChangeTrafficType"
                    >
                      <el-option
                        label="不限量"
                        :value="1"
                        :disabled="scheduleForm.erpSubOrder !== ''"
                      ></el-option>
                      <el-option label="总共投" :value="2"></el-option>
                      <el-option label="分天投" :value="4"></el-option>
                    </el-select>
                    <template slot="append" v-if="scheduleForm.trafficType !== 1">
                      <el-select
                        v-model="scheduleForm.trafficUnit"
                        slot="prepend"
                        placeholder="请选择"
                        :disabled="disableForm.trafficTypeDisabled"
                      >
                        <el-option label="CPM" :value="0"></el-option>
                      </el-select>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 总共投，填写总量 -->
            <template v-if="scheduleForm.trafficType === 2">
              <el-row>
                <el-col :span="12">
                  <el-form-item prop="payTraffic">
                    <label slot="label">
                      排期总量
                      <el-tooltip
                        v-if="erpModeSwitch !== 0"
                        class="item"
                        effect="light"
                        placement="top-start"
                      >
                        <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                        <div slot="content">
                          关联{{
                            erpModeSwitch === 2 ? '销售子订单' : 'ERP订单'
                          }}才可设置排期量
                        </div>
                      </el-tooltip>
                    </label>
                    <el-input
                      v-model.trim="scheduleForm.payTraffic"
                      :disabled="
                        (disableForm.trafficTypeDisabled &&
                          scheduleForm.trafficType === 4) ||
                        payTrafficDisabled
                      "
                      @change="handlePayTrafficChange"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="赠送总量" prop="freeTraffic">
                    <el-input
                      v-model.trim="scheduleForm.freeTraffic"
                      :disabled="
                        disableForm.trafficTypeDisabled && scheduleForm.trafficType === 4
                      "
                      @change="handleFreeTrafficChange"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="补量总量" prop="addedTraffic">
                    <el-input
                      v-model.trim="scheduleForm.addedTraffic"
                      :disabled="
                        disableForm.trafficTypeDisabled && scheduleForm.trafficType === 4
                      "
                      @change="handleAddedTrafficChange"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <!-- 分天投，填写分天排期 -->
            <template v-if="scheduleForm.trafficType === 4">
              <el-row>
                <el-col :span="16">
                  <el-form-item prop="isCorrect">
                    <label slot="label">
                      每日排期量
                      <el-tooltip
                        v-if="erpModeSwitch !== 0"
                        class="item"
                        effect="light"
                        placement="top-start"
                      >
                        <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                        <div slot="content">
                          关联{{
                            erpModeSwitch === 2 ? '销售子订单' : 'ERP订单'
                          }}才可设置排期量
                        </div>
                      </el-tooltip>
                    </label>
                    <el-input
                      v-model="scheduleForm.isCorrect"
                      style="display: none"
                    ></el-input>
                    <el-input
                      v-model="scheduleForm.payDailyTraffic"
                      class="demo-ruleForm-textarea"
                      type="textarea"
                      placeholder="按顺序输入每日计划投放量，用空格、逗号或顿号分割，不投放日期用0或-占位。支持直接从excel复制。"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      :disabled="dailyTrafficDisabled || payTrafficDisabled"
                      @change="handleChangeDailyTraffic"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" style="margin-left: 10px">
                  <el-button
                    v-show="showEditDailyTrafficBtn && !payTrafficDisabled"
                    @click="editDailyTraffic"
                    >编辑</el-button
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <el-form-item label="每日赠送量" prop="isFreeCorrect">
                    <el-input
                      v-model="scheduleForm.isFreeCorrect"
                      style="display: none"
                    ></el-input>
                    <el-input
                      v-model="scheduleForm.freeDailyTraffic"
                      class="demo-ruleForm-textarea"
                      type="textarea"
                      placeholder="按顺序输入每日计划投放量，用空格、逗号或顿号分割，不投放日期用0占位。支持直接从excel复制。"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      :disabled="dailyTrafficDisabled"
                      @change="handleChangeDailyTraffic"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" style="margin-left: 10px">
                  <el-button v-show="showEditDailyTrafficBtn" @click="editDailyTraffic"
                    >编辑</el-button
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <el-form-item label="每日补量" prop="isAddedCorrect">
                    <el-input
                      v-model="scheduleForm.isAddedCorrect"
                      style="display: none"
                    ></el-input>
                    <el-input
                      v-model="scheduleForm.addedDailyTraffic"
                      class="demo-ruleForm-textarea"
                      type="textarea"
                      placeholder="按顺序输入每日计划投放量，用空格、逗号或顿号分割，不投放日期用0占位。支持直接从excel复制。"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      :disabled="dailyTrafficDisabled"
                      @change="handleChangeDailyTraffic"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" style="margin-left: 10px">
                  <el-button v-show="showEditDailyTrafficBtn" @click="editDailyTraffic"
                    >编辑</el-button
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="预览">
                    <div class="form-table" v-show="dailyTrafficTable.length">
                      <div class="form-table-box">
                        <div class="form-table-box-th"></div>
                        <div class="form-table-box-td">投放总量</div>
                        <div class="form-table-box-td">排期量</div>
                        <div class="form-table-box-td">赠送量</div>
                        <div class="form-table-box-td">补量</div>
                      </div>
                      <div
                        class="form-table-box"
                        v-for="(item, index) in dailyTrafficTable"
                        :key="'d' + index"
                      >
                        <div
                          :class="
                            item.isWeek ? 'form-table-box-th-light' : 'form-table-box-th'
                          "
                        >
                          {{ item.daily.substring(5, 10) }}
                        </div>
                        <div class="form-table-box-td">{{ item.totalTraffic }}</div>
                        <div class="form-table-box-td">{{ item.payTotalTraffic }}</div>
                        <div class="form-table-box-td">{{ item.freeTotalTraffic }}</div>
                        <div class="form-table-box-td">{{ item.addedTotalTraffic }}</div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <el-row>
              <el-col>
                <el-form-item label="频次控制">
                  <div class="item-frequency">
                    <el-radio-group
                      :value="scheduleForm.frequency"
                      :disabled="disableForm.frequencyDisabled"
                      @input="handleChangeFrequency"
                    >
                      <template v-for="(item, index) in freOptions">
                        <el-radio
                          class="code-radio"
                          :key="'f' + index"
                          :label="item.label"
                          >{{ item.name }}</el-radio
                        >
                      </template>
                    </el-radio-group>
                    <template v-if="scheduleForm.frequency !== 1">
                      <el-form-item prop="trafficDaily">
                        <InputPositiveInt
                          v-model="scheduleForm.trafficDaily"
                          @input="handleTrafficDailyInput"
                        />&nbsp;次
                      </el-form-item>
                    </template>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <div class="el-form-item">
                  <label class="el-form-item__label" style="width: 112px">
                    双周期频控
                    <el-tooltip class="item" effect="light" placement="top-start">
                      <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                      <div slot="content">
                        双周期频控，是指一个计划单支持一个大周期+一个大周期内小周期的频控。
                        <br />比如月控10次且日控2次。
                      </div>
                    </el-tooltip>
                  </label>
                  <div class="el-form-item__content" style="margin-left: 112px">
                    <div class="item-frequency">
                      <el-radio-group
                        v-model="scheduleForm.subFrequency"
                        :disabled="subFrequencyDisabled"
                        @change="handleChangeSubfrequency"
                      >
                        <el-radio-button :label="1">否</el-radio-button>
                        <el-radio-button
                          v-for="(item, index) in subFreqOptions"
                          :key="'double' + index"
                          :label="item.label"
                          >{{ item.name }}</el-radio-button
                        >
                      </el-radio-group>
                      <template v-if="scheduleForm.subFrequency !== 1">
                        <el-form-item prop="subTrafficDaily" label-width="0px">
                          <InputPositiveInt
                            v-model="scheduleForm.subTrafficDaily"
                            @input="handleSubTrafficDailyInput"
                          />&nbsp;次
                        </el-form-item>
                      </template>
                      <span style="color: #ff8b00">&nbsp;&nbsp;只自有流量生效</span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="showUnionFreq">
              <el-col>
                <el-form-item label="关联频控" :disabled="disableForm.frequencyDisabled">
                  <el-row>
                    <el-col :span="16">
                      <div class="item-frequency">
                        <el-radio-group
                          v-model="scheduleForm.unionSequence"
                          @change="handleCleanAllSelectTable"
                        >
                          <el-radio-button :label="0">否</el-radio-button>
                          <el-radio-button :label="2" :disabled="unSeqDisabled">
                            <el-tooltip effect="light" placement="top-start">
                              <i
                                class="el-icon-cc-info-circle"
                                style="font-size: 14px"
                              ></i>
                              <div slot="content">
                                计划单曝光顺序与顺序无关
                              </div> </el-tooltip
                            >无序
                          </el-radio-button>
                          <el-radio-button
                            :label="1"
                            :disabled="inSeqDisabled || scheduleForm.subFrequency !== 1"
                          >
                            <el-tooltip effect="light" placement="top-start">
                              <i
                                class="el-icon-cc-info-circle"
                                style="font-size: 14px"
                              ></i>
                              <div slot="content">
                                按顺序曝光计划单，计划单频次必须一致
                              </div> </el-tooltip
                            >有序
                          </el-radio-button>
                        </el-radio-group>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    v-if="scheduleForm.unionSequence != 0"
                    class="union-row"
                    :gutter="20"
                  >
                    <el-col :span="10" class="union-frequency">
                      <el-form-item prop="unionFreq" label-width="180px">
                        <div slot="label">
                          <span style="padding-right: 20px">频次控制</span>
                          <span>{{ $consts.frequencyText[scheduleForm.frequency] }}</span>
                        </div>
                        <InputPositiveInt
                          v-model="scheduleForm.unionFreq"
                          :disabled="scheduleForm.unionSequence === 1"
                        />&nbsp;次
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" class="union-frequency">
                      <el-form-item
                        v-if="scheduleForm.subFrequency !== 1"
                        prop="subUnionFreq"
                        label-width="180px"
                      >
                        <div slot="label">
                          <span style="padding-right: 20px">双周期频控</span>
                          <span>{{
                            $consts.frequencyText[scheduleForm.subFrequency]
                          }}</span>
                        </div>
                        <InputPositiveInt
                          v-model="scheduleForm.subUnionFreq"
                          :disabled="scheduleForm.unionSequence === 1"
                        />&nbsp;次
                      </el-form-item>
                    </el-col>
                    <el-col style="margin-top: 16px">
                      <UnionScheduleInfo
                        :orderNo="order.orderNo"
                        :scheduleInfo="scheduleForm"
                        :cleanBtnDisabled="cleanBtnDisabled"
                        @clean-all="handleCleanAllSelectTable"
                        @confirm="handleUnionScheduleConfirm"
                      ></UnionScheduleInfo>
                    </el-col>
                    <el-col>
                      <el-form-item prop="unionFreqCheck">
                        <div style="margin-top: 16px">
                          <template v-if="selectTable.data.length > 0">
                            <Table
                              :props="selectTable.props"
                              ref="selectTable"
                              :data="selectTable.data"
                              :header="selectTable.header"
                            />
                          </template>
                        </div>
                        <el-input
                          v-model="scheduleForm.unionFreqCheck"
                          style="display: none"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <div class="el-form-item" v-if="isOwn && !iqyCableChannel">
                  <label class="el-form-item__label" style="width: 112px">
                    家庭去重
                    <el-tooltip class="item" effect="light" placement="top-start">
                      <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                      <div slot="content">
                        家庭去重是指,当同一家庭中有
                        <br />OTT（网络电视）、IPTV（广电网络数字电视）、DVB（机顶盒）等多个终端时，
                        <br />仅对其中一台进行广告投放
                      </div>
                    </el-tooltip>
                  </label>
                  <div class="el-form-item__content" style="margin-left: 112px">
                    <el-radio-group v-model="scheduleForm.homeDeWeight">
                      <el-radio-button :label="0">否</el-radio-button>
                      <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="自动补量" v-if="isOwn">
                  <el-radio-group
                    v-model="scheduleForm.autoFilling"
                    :disabled="disableForm.autoFillingDisabled"
                  >
                    <el-radio-button :label="1">否</el-radio-button>
                    <el-radio-button :label="0">是</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="scheduleForm.planType === 1">
              <el-col>
                <el-form-item label="放量溢出比" prop="receivePct">
                  <div class="flex-form-item">
                    <el-radio-group
                      v-model="receivePctType"
                      @change="handleChangePctType"
                    >
                      <el-radio-button :label="0">默认</el-radio-button>
                      <el-radio-button :label="1">自定义</el-radio-button>
                    </el-radio-group>
                    <template v-if="receivePctType === 1">
                      <el-input
                        class="form-item-select"
                        v-model="scheduleForm.receivePct"
                      ></el-input
                      >&nbsp;%
                    </template>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="曝光溢出比" prop="exposurePct">
                  <el-radio-group
                    v-model="exposurePctType"
                    @change="handleChangeExposurePctType"
                  >
                    <el-radio-button :label="0">默认</el-radio-button>
                    <el-radio-button :label="1">自定义</el-radio-button>
                    <el-radio-button :label="2">溢出比考核</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col v-if="exposurePctType !== 0" class="flex-form-items">
                <el-form-item
                  :label="exposurePctType === 2 ? '考核值' : '溢出比'"
                  label-width="60px"
                  prop="checkExposurePct"
                >
                  <el-input
                    class="flex-form-content"
                    v-model.number="scheduleForm.checkExposurePct"
                    @change="calcExposurePct"
                  ></el-input
                  >&nbsp;%
                </el-form-item>
                <template v-if="exposurePctType === 2">
                  <el-form-item label="额外溢出" label-width="80px" prop="addExposurePct">
                    <el-input
                      v-model.number="scheduleForm.addExposurePct"
                      class="flex-form-content"
                      placeholder="可填0"
                      @change="calcExposurePct"
                    ></el-input
                    >&nbsp;%
                  </el-form-item>
                  <el-form-item label="总计" label-width="50px" prop="exposurePct">
                    <div style="width: 160px">
                      <span style="width: 60px; font-weight: 600">{{
                        scheduleForm.exposurePct
                      }}</span
                      >&nbsp;%
                    </div>
                  </el-form-item>
                </template>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="售卖价格">
                  <template v-if="erpModeSwitch !== 0">
                    <span
                      >{{ parseFloat(scheduleForm.sellingPrice || 0) }} 元/{{
                        order.sellingType === 1 ? 'CPM' : 'CPD'
                      }}</span
                    >
                  </template>
                  <template v-else>
                    <el-input
                      class="input-with-select"
                      v-model="scheduleForm.sellingPrice"
                      placeholder="请输入最多小数点前7位，小数点后4位"
                    >
                      <template slot="append"
                        >元/{{ order.sellingType === 1 ? 'CPM' : 'CPD' }}</template
                      >
                    </el-input>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
          </ContentBox>
          <ContentBox title="定向" id="定向">
            <el-row v-if="!iqyCableChannel">
              <el-col>
                <el-form-item label="MAC定向" v-if="isOwn">
                  <MacForm
                    ref="mac"
                    v-model="scheduleForm.macList"
                    :disabled="disableForm.macDisabled"
                  ></MacForm>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="showOtherDirections && !iqyCableChannel && isOwn">
              <el-col>
                <el-form-item label="定制机型标签">
                  <el-select
                    v-model="customTag"
                    filterable
                    clearable
                    class="form-select"
                    @change="setCustomTagDirect"
                  >
                    <el-option
                      v-for="(item, index) in customTagList"
                      :key="index"
                      :value="item.adCustomTagId"
                      :label="item.adCustomTagName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <template v-if="showOtherDirections">
              <el-row>
                <el-col>
                  <el-form-item label="区域定向">
                    <el-radio-group
                      v-model="scheduleForm.areaType"
                      :disabled="disableForm.areaDisabled"
                      @change="handleChangeAreaType"
                    >
                      <el-radio-button :label="0">全国</el-radio-button>
                      <el-radio-button :label="1">选定区域</el-radio-button>
                    </el-radio-group>
                    <template
                      v-if="regionsData.length > 0 && scheduleForm.areaType !== 0"
                    >
                      <CommonSelectPannel
                        v-model="scheduleForm.regionList"
                        ref="regionPannel"
                        selectPlaceholder="请输入关键词"
                        :reverse="reverse"
                        :disabled="disableForm.areaDisabled"
                        :leftData="regionsData"
                        :selectPanelColumns="['地区', '城市']"
                        @input="customTag = ''"
                      >
                        <template slot="extraBtn">
                          <PopNlpBatchAdd
                            ref="popBatchAdd"
                            class="extra-item"
                            :btn-name="popBatch.btnName"
                            :label="popBatch.label"
                            :placeholder="popBatch.placeholder"
                            @save-add="saveBatchAddArea"
                          ></PopNlpBatchAdd>
                        </template>
                      </CommonSelectPannel>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <el-row v-if="showOtherDirections">
              <el-col>
                <el-form-item label="定向包">
                  <div style="display: flex">
                    <el-select
                      v-model="directPackageId"
                      filterable
                      clearable
                      class="form-select"
                      @change="setDirectPackage"
                    >
                      <el-option
                        v-for="(item, index) in directPackageOpts"
                        :key="index"
                        :value="item.directPackageId"
                        :label="item.directPackageName"
                      ></el-option>
                    </el-select>
                    <span style="padding-left: 12px; color: #969aa0; font-size: 12px">
                      <i class="el-icon-warning"></i>
                      区域定向不会因定向包而修改
                    </span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <template v-if="showOtherDirections && !iqyCableChannel">
              <el-row>
                <el-col>
                  <el-form-item label="尺寸定向">
                    <div style="display: flex">
                      <el-radio-group
                        v-model="scheduleForm.deviceSizeData"
                        :class="isMac ? '' : 'demo-ruleForm-radio-own'"
                        @change="handleChangeSize"
                      >
                        <el-radio-button
                          v-for="(item, index) in deviceSizeList"
                          :label="item.value"
                          :key="'s' + index"
                          >{{ item.label }}</el-radio-button
                        >
                      </el-radio-group>
                    </div>
                    <template v-if="scheduleForm.deviceSizeData === '0'">
                      <el-row>
                        <el-col :span="6">
                          <el-form-item prop="minSize">
                            <el-input
                              class="demo-ruleForm-min-input"
                              v-model="scheduleForm.minSize"
                              placeholder="最小尺寸"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1">
                          <div style="text-align: center">-</div>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item prop="maxSize">
                            <el-input
                              class="demo-ruleForm-min-input"
                              v-model="scheduleForm.maxSize"
                              placeholder="最大尺寸"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="品牌机型" v-if="isOwn" prop="brandList">
                    <el-radio-group
                      v-model="scheduleForm.brandType"
                      :disabled="directinal.isNeedBrands"
                      @change="handleChangeBrandType"
                    >
                      <el-radio-button :label="0">不限</el-radio-button>
                      <el-radio-button :label="1">选择品牌机型</el-radio-button>
                    </el-radio-group>
                    <template v-if="scheduleForm.brandType === 1">
                      <CommonSelectPannel
                        v-model="scheduleForm.brandList"
                        ref="barnd"
                        :leftData="availableBrandList"
                        :selectPanelColumns="['品牌', '机型']"
                        @input="clearPackage"
                      ></CommonSelectPannel>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="视频源定向" v-if="isOwn">
                    <el-checkbox-group
                      v-model="scheduleForm.videoSource"
                      @change="handleChangeVideoSource"
                    >
                      <el-checkbox-button :label="0">不限</el-checkbox-button>
                      <el-checkbox-button
                        v-for="item in videoSourceList"
                        :label="item.value"
                        :key="item.value"
                        >{{ item.label }}</el-checkbox-button
                      >
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isOwn">
                <el-col>
                  <el-form-item label="自定义标签">
                    <el-radio-group
                      v-model="scheduleForm.customTagType"
                      @change="hanldeChangeCustomTagType"
                    >
                      <el-radio-button :label="0">不限</el-radio-button>
                      <el-radio-button :label="1">MAC包</el-radio-button>
                      <el-radio-button :label="3">LBS标签</el-radio-button>
                    </el-radio-group>
                    <template v-if="scheduleForm.customTagType !== 0">
                      <el-radio v-model="scheduleForm.customMatchRule" label="in"
                        >定向所选标签</el-radio
                      >
                      <el-radio v-model="scheduleForm.customMatchRule" label="notin"
                        >排除所选标签</el-radio
                      >
                      <template v-if="scheduleForm.customTagType === 1">
                        <CommonSelectPannel
                          v-model="scheduleForm.macTags"
                          :leftData="macTagList"
                          :selectPanelColumns="['标签']"
                          @input="clearPackage"
                        ></CommonSelectPannel>
                      </template>
                      <template v-if="scheduleForm.customTagType === 3">
                        <CommonSelectPannel
                          v-model="scheduleForm.lbsTags"
                          :leftData="lbsTagList"
                          :selectPanelColumns="['标签']"
                          @input="clearPackage"
                        ></CommonSelectPannel>
                      </template>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isOwn">
                <el-col>
                  <el-form-item label="DMP标签">
                    <el-radio-group
                      v-model="scheduleForm.dmpMatchType"
                      @change="handleChangeDmpSelectType"
                    >
                      <el-radio-button :label="-1">不限</el-radio-button>
                      <el-radio-button :label="1">任意匹配</el-radio-button>
                      <el-radio-button :label="0">全部匹配</el-radio-button>
                      <el-radio-button :label="2">排除</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item v-if="scheduleForm.dmpMatchType !== -1">
                    <PopTableSelect
                      v-model="scheduleForm.policyName"
                      :title="poper.title"
                      :table="poper.table"
                      @data-select="handleDmpSelect"
                    ></PopTableSelect>
                  </el-form-item>
                  <el-form-item v-if="scheduleForm.policyName" prop="dmpTags">
                    <CommonSelectPannel
                      v-model="scheduleForm.dmpTags"
                      :leftData="dmpTagList"
                      :selectPanelColumns="['人群']"
                      @input="clearPackage"
                    ></CommonSelectPannel>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isOwn">
                <el-col>
                  <el-form-item label="广告DMP">
                    <el-radio-group
                      v-model="scheduleForm.crowdMatchType"
                      @change="clearPackage"
                    >
                      <el-radio-button :label="-1">不限</el-radio-button>
                      <el-radio-button :label="3">自定义</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item v-if="scheduleForm.crowdMatchType !== -1">
                    <CrowdSelectPannel
                      v-model="crowdIdList"
                      ref="crowd"
                      :echoData="crowdEchoData"
                      @selected="handleCrowdSelected"
                    ></CrowdSelectPannel>
                    <el-button type="text" class="ad-text-btn" @click="handleJumpToDmp"
                      >管理自定义人群包</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <el-row v-if="isOwn">
              <el-col>
                <el-form-item label="三方DMP">
                  <el-radio-group v-model="thirdDmpId" @change="handleThirdDmpChange">
                    <el-radio-button :label="-1">不限</el-radio-button>
                    <el-radio-button
                      v-for="(item, index) in thirdDmpOptions"
                      :key="index"
                      :label="item.dmpId"
                      >{{ item.partnersName }}</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="thirdDmpId !== -1">
                <CommonBusiness
                  v-model="dmpComponentList"
                  ref="thirdDmp"
                  style="margin-left: 112px"
                  labelWidth="160px"
                  @change="directPackageId = ''"
                ></CommonBusiness>
              </el-col>
            </el-row>
            <el-row v-if="scheduleForm.businessList.length > 0">
              <el-col>
                <CommonBusiness
                  ref="bussiness"
                  v-model="scheduleForm.businessList"
                  @change="directPackageId = ''"
                ></CommonBusiness>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="场景标签" v-if="mediaTagList.length > 0">
                  <CommonTreeSelectPannel
                    :leftData="mediaTagList"
                    v-model="scheduleForm.mediaTags"
                    :selectPanelColumns="['一级标签', '二级标签', '三级标签']"
                  ></CommonTreeSelectPannel>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="spaceNo === 'CCADTV10036'">
              <el-col>
                <el-form-item label="推荐流" prop="recId">
                  <el-select
                    v-model="scheduleForm.recId"
                    filterable
                    class="form-select"
                    :disabled="mode !== 'create' && scheduleForm.scheduleStatus !== 1"
                  >
                    <el-option
                      v-for="item in recStreamOptions"
                      :key="item.value"
                      :label="`${item.label} (${item.value})`"
                      :value="item.value"
                    >
                      {{ item.label }}
                      <span class="popper-option__tail">({{ item.value }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="showOtherDirections">
              <el-col>
                <el-form-item label="存为定向包" prop="directPackageName">
                  <div class="flex-form-item">
                    <el-radio-group
                      v-model="scheduleForm.directPackageSave"
                      @change="scheduleForm.directPackageName === ''"
                    >
                      <el-radio-button :label="0">否</el-radio-button>
                      <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                    <template v-if="scheduleForm.directPackageSave === 1">
                      <el-input
                        v-model="scheduleForm.directPackageName"
                        clearable
                        show-word-limit
                        style="margin: 0 10px; width: 400px"
                        placeholder="请输入定向包名称"
                        maxlength="25"
                      ></el-input>
                      <span style="padding-left: 12px; color: #969aa0; font-size: 12px">
                        <i class="el-icon-warning"></i>
                        区域定向不会因定向包而修改
                      </span>
                    </template>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </ContentBox>
          <ContentBox title="计划名称" id="计划名称">
            <el-row>
              <el-col>
                <el-form-item label="计划名称" prop="scheduleName">
                  <el-input
                    v-model="scheduleForm.scheduleName"
                    placeholder="请填写计划名称"
                    maxlength="45"
                    show-word-limit
                    clearable
                    @change="handleManualScheduleName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </ContentBox>
          <ContentBox class="content-box">
            <el-row>
              <el-col>
                <FormButton
                  :formButtonObj="formButtonObj"
                  @clickType="handleClickType"
                ></FormButton>
              </el-col>
            </el-row>
          </ContentBox>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import CommonLazySelect from '@/components/common/CommonLazySelect'
import PopTableSelect from '@/components/common/PopTableSelect'
import PopNlpBatchAdd from '@/components/common/PopNlpBatchAdd'
import { InputPositiveInt } from '@ccprivate/admin-toolkit'
import MacForm from './scheduleDirection/Mac'
import CommonSelectPannel from './scheduleDirection/CommonSelectPannel'
import CrowdSelectPannel from './scheduleDirection/CrowdSelectPannel'
import CommonBusiness from './scheduleDirection/CommonBusiness'
import FormButton from './AdFormButton'
import CommonTreeSelectPannel from './scheduleDirection/CommonTreeSelectPannel'
import UnionScheduleInfo from './UnionScheduleInfo'
import CheckBoxGroup from './CheckBoxGroup'
import ExtendParam from './ExtendParam'
import validator from './schedule/validator'
import ErpOrderSelecter from '@/components/schedule/ErpOrderSelecter.vue'
import PvFrequency from '@/components/schedule/PvFrequency.vue'
import {
  detectOS,
  buildRegionData,
  freOptions,
  handleDeviceSize,
  handleFormRegionDaily,
  handleFormMediaTags,
  handleReviewMedia,
  handleReviewRegion,
  handleReviewPannelData,
  handleReviewDmp,
  handleFormTimeList,
  handleBrand,
  getDailyTraffics,
  stringToInt,
  getReviewDailyTraffic,
  getBetweenDate,
  checkPutTime
} from './schedule/utils'
import useSpaceComponent from '@/hooks/useSpaceComponent'

export default {
  components: {
    CommonLazySelect,
    PopTableSelect,
    PopNlpBatchAdd,
    InputPositiveInt,
    MacForm,
    CommonSelectPannel,
    CrowdSelectPannel,
    CommonBusiness,
    FormButton,
    CommonTreeSelectPannel,
    UnionScheduleInfo,
    CheckBoxGroup,
    ExtendParam,
    ErpOrderSelecter,
    PvFrequency
  },
  props: ['order', 'value', 'mode', 'editForm', 'isLockPreviousStep', 'cableCheckable'],
  mixins: [validator],
  data() {
    return {
      scheduleTaUvKpi: [0],
      kpiList: [
        { key: 'N+UV', label: 'N+UV' },
        { key: 'TA', label: 'TA' }
      ],
      scheduleTaUv: {
        crowdTagId: '',
        scheduleTaUvId: '',
        orderId: '',
        scheduleId: '',
        taStatus: 0,
        uvStatus: 0,
        uvTarget: null,
        uvPercentage: null,
        taCondition: ''
      },
      isMac: false,
      customTag: '', // 自定义标签
      customTagList: [],
      directPackageId: '', // 定向包
      directPackageOpts: [],
      reverse: true, // 支持反选
      thirdDmpId: -1, // 第三方dmpId
      thirdDmpOptions: [],
      pvRateType: 0,
      pvRateOptions: [],
      freOptions,
      scheduleForm: this.genScheduleForm(),
      directinal: {},
      brandsModelsList: [], // 品牌机型数据
      channelIdList: [], // 投放渠道
      deviceSizeList: [], // 尺寸
      dmpTagList: [], // dmp
      lbsTagList: [], // lbs标签
      macTagList: [], // mac标签
      paymentList: [], // 结算方式
      regionsData: [], // 地区数据
      scheduleSourceList: [], // 程序化来源
      saleTypeOptions: [],
      seqList: [], // 优先级
      spaceList: [], // 广告位
      videoSourceList: [], // 视频源
      mediaTagList: [], // 广告媒资标签
      cableChannelList: [], // 媒体方
      extendParamType: 0, // 扩展参数类型（0无，1配置）
      extendParamList: [],
      template: null,
      templateList: [],
      ctrType: 0,
      receivePctType: 0, // (放量溢出比 0默认 1自定义)
      exposurePctType: 0,
      receivePct: 0,
      spacePctRatio: 0,
      subOrderOptions: [],
      isChangeConfirmForm: {
        sourceStatus: false
      },
      rules: {
        taCondition: [{ required: true, message: '请输入TA考核条件', trigger: 'blur' }],
        uvTarget: [
          { required: true, message: '请输入2~100的整数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (+value <= 1) {
                return callback(new Error('请输入2~100的整数'))
              }
              value = parseInt(value)
              if (value > 100) {
                return callback(new Error('请输入2~100的整数'))
              }
              this.scheduleForm.uvTarget = parseInt(value)
              callback()
            },
            trigger: ['blur']
          }
        ],
        uvPercentage: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                return callback(new Error('请输入'))
              }
              if (+value <= 0) {
                return callback(new Error('请输入大于0的数字'))
              }
              if (+value >= 100) {
                return callback(new Error('请输入小于100的数字'))
              }
              let uvPercentage = String(value).replace(/^\D*(\d*\.?\d{0,2})?.*$/, '$1')
              this.$set(this.scheduleForm, 'uvPercentage', uvPercentage)
              callback()
            }
          }
        ],
        uvCanSelect: [
          {
            validator: (rule, value, callback) => {
              if (
                this.scheduleForm.frequency === 1 &&
                this.scheduleTaUvKpi.includes('N+UV')
              ) {
                return callback(new Error('频控不限，不能配置N+UV指标'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      putTimeListRules: {
        timeDay: [
          { required: true, message: '请选择投放时间', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (
                this.scheduleForm.dateType === 1 &&
                this.scheduleForm.putTimeList.some((item) => !item.timeHours)
              ) {
                return callback(new Error('投放时间段不完整'))
              }
              if (checkPutTime(this.scheduleForm.putTimeList)) {
                return callback(new Error('选择的时间有重复'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      pickingIndex: 0,
      spaceNo: undefined,
      isHasManualScheduleName: false, // 是否手动更改过名字
      showEditDailyTrafficBtn: false, // 是否显示编辑按钮
      dailyTrafficDisabled: this.mode !== 'create', // 每日计划量是否可编辑
      isAllowEditStatus: [2, 3, 4, 9], // 草稿的随便改
      oldNeedSubmitObj: {},
      btnType: undefined, // 点击按钮的类型
      triggerDialogFormStatus: {
        spaceIdChange: false,
        scheduleSourceChange: false,
        planTypeChange: false,
        supportModeChange: false,
        frequency: false
      },
      formButtonObj: {
        cancel: {
          name: '取消',
          disabled: false,
          show: true,
          method: this.handleCancel,
          plain: true
        },
        saveClose: {
          name: '保存草稿',
          disabled: false,
          loading: false,
          show: false,
          method: this.handleSaveClose,
          plain: true
        },
        saveAuditAndEditMedia: {
          name: '下一步', // 需要送审
          disabled: true, // 主要信息填写后不禁用
          loading: false,
          show: false,
          method: this.handleSaveAuditAndEditMedia,
          type: 'primary',
          plain: false
        },
        submitAuditAndEditMedia: {
          name: '下一步',
          disabled: false, // 编辑显示。默认是不禁用
          loading: false,
          show: false,
          method: this.handleSubmitAndEditMeida,
          plain: true
        },
        submitAudit: {
          name: '提交审核',
          disabled: false, // 编辑显示。默认是不禁用
          loading: false,
          show: false,
          type: 'primary',
          method: this.handleSubmitAudit
        }
      },
      selectTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            prop: 'unionSeq',
            label: '顺序',
            render: (h, { row }) => {
              return (
                <InputPositiveInt
                  value={row.unionSeq}
                  disabled={row.seqDisabled}
                  onInput={(event) => (row.unionSeq = event ? event * 1 : '')}
                />
              )
            }
          },
          {
            prop: 'scheduleNo',
            label: '计划单号',
            'min-width': '150'
          },
          {
            prop: 'scheduleName',
            label: '计划名称',
            'min-width': '180',
            'show-overflow-tooltip': true
          },
          {
            prop: 'frequency',
            label: '频次控制',
            'min-width': '120',
            formatter: (params) => {
              return (
                this.$consts.frequencyText[params.frequency] + params.trafficDaily + '次'
              )
            }
          },
          {
            prop: 'subFrequency',
            label: '双周期频控',
            'min-width': '120',
            show: this.scheduleForm && this.scheduleForm.subFrequency !== 1,
            formatter: (params) => {
              return params.subFrequency !== 1
                ? this.$consts.frequencyText[params.subFrequency] +
                    params.subTrafficDaily +
                    '次'
                : this.$consts.frequencyText[params.subFrequency]
            }
          },
          {
            prop: 'scheduleStatus',
            label: '状态',
            'min-width': '80',
            formatter: (params) => {
              return this.$consts.shceduleStatusText[params.scheduleStatus]
            }
          },
          {
            label: '操作',
            render: (h, { row }) => {
              return (
                <el-button
                  type="text"
                  disabled={row.disabled}
                  onClick={() => this.handleDeleteSelectTable(row)}
                >
                  移除
                </el-button>
              )
            }
          }
        ],
        data: []
      },
      poper: {
        title: '添加人群',
        table: {
          props: {
            border: true,
            'tooltip-effect': 'dark',
            'row-style': { height: '40px' },
            'cell-style': { padding: '0' },
            'max-height': 480
          },
          header: [
            {
              label: 'ID',
              align: 'left',
              prop: 'policyId',
              width: 100,
              'show-overflow-tooltip': true
            },
            {
              label: '人群策略名称',
              align: 'left',
              prop: 'policyName',
              query: true,
              placeholder: '请输入人群策略名称',
              'min-width': 180,
              'show-overflow-tooltip': true
            },
            {
              label: '创建时间',
              prop: 'createTime',
              'min-width': 100,
              'show-overflow-tooltip': true
            }
          ],
          api: this.$service.getDmpPolicyList
        }
      },
      popBatch: {
        btnName: '批量添加区域',
        label: '省份城市',
        placeholder: '不同省、市或区通过英文逗号、空格或顿号隔开，支持城市级别精准输入'
      },
      dmpComponentList: [],
      crowdIdList: [],
      crowdEchoData: [],
      planTypeList: [],
      oldPayTraffics: [],
      oldFreeTraffics: [],
      oldAddedTraffics: [],
      supportedSpaceNos: [],
      erpModeSwitch: 0,
      dealIdType: 0,
      unSeqDisabled: false,
      inSeqDisabled: false,
      backupSize: '-1',
      mediaTimes: undefined,
      recStreamOptions: []
    }
  },
  computed: {
    isHasNewSystem() {
      const isSelectChannelList = this.channelIdList.filter(
        (item) => item.value === this.scheduleForm.channelId
      )
      if (isSelectChannelList.length > 0) {
        return isSelectChannelList.some((item) => item.type === 1)
      } else {
        return false
      }
    },
    paymentOptions() {
      if (this.scheduleForm.erpSubOrder) {
        return this.paymentList.filter((item) => item.value === 0)
      }
      return this.paymentList
    },
    spaceOptions() {
      if (this.supportedSpaceNos.length) {
        return this.spaceList.filter((item) =>
          this.supportedSpaceNos.includes(item.spaceNo)
        )
      }
      return this.spaceList
    },
    payTrafficDisabled() {
      if (this.erpModeSwitch === 0) return false
      const erpEmpty = this.erpModeSwitch === 1 && !this.scheduleForm.erpSubOrder
      const salesEmpty = this.erpModeSwitch === 2 && !this.scheduleForm.suborderNo
      const trafficEmpty =
        (this.scheduleForm.trafficType === 2 && !this.scheduleForm.payTraffic) ||
        (this.scheduleForm.trafficType === 4 && !this.scheduleForm.payDailyTraffic)
      return (erpEmpty || salesEmpty) && trafficEmpty
    },
    isOwn() {
      let show = false
      if (this.scheduleForm.channelId || this.scheduleForm.channelId === 0) {
        const isSelectChannelList = this.channelIdList.filter(
          (item) => item.value === this.scheduleForm.channelId
        )
        if (isSelectChannelList.length > 0) {
          const type = isSelectChannelList[0].type
          // 选择非自有时，不显示快速投放按钮
          if (type === 0) {
            show = true
          }
        }
      }
      return show
    },
    // 选择mac定向的时候不显示区域 尺寸 品牌机型，视频源定向
    showOtherDirections() {
      if (this.scheduleForm.macList.some((item) => item.beginMac || item.endMac)) {
        return false
      } else {
        return true
      }
    },
    iqyCableChannel() {
      return (
        this.scheduleForm.cableChannelList &&
        this.scheduleForm.cableChannelList.indexOf('IQIYI') > -1
      )
    },
    // 选择自有投放渠道后，过滤品牌机型， 还需要处理定向信息
    availableBrandList() {
      return handleBrand(this.brandsModelsList)
    },
    // 选择程序化来源之后，要显示程序化类型
    showSupportMode() {
      let obj = {
        pdb: true,
        pd: false,
        cpdb: false
      }
      if (
        this.scheduleForm.planType === 1 &&
        this.scheduleForm.scheduleSource !== undefined
      ) {
        const isSelectScheduleSourceList = this.scheduleSourceList.filter(
          (item) => item.value === this.scheduleForm.scheduleSource
        )
        if (isSelectScheduleSourceList.length > 0) {
          obj = {
            pdb: isSelectScheduleSourceList[0].supportMode.includes(0),
            pd: isSelectScheduleSourceList[0].supportMode.includes(1),
            cpdb: isSelectScheduleSourceList[0].supportMode.includes(2)
          }
        }
      }
      return obj
    },
    // 自有渠道、新系统且非双周期 显示关联频控
    showUnionFreq() {
      if (
        (this.isOwn || (!this.isOwn && this.scheduleForm.subFrequency === 1)) &&
        this.scheduleForm.frequency > 1
      ) {
        return true
      } else {
        return false
      }
    },
    disableForm() {
      let obj = {
        planTypeDisabled: false,
        scheduleSourceDisabled: false,
        showSupportModeDisabled: false,
        saleTypeDisabled: false,
        channelDisabled: false,
        spaceDisabled: false,
        trafficTypeDisabled: false,
        autoFillingDisabled: false,
        macDisabled: false,
        areaDisabled: false,
        frequencyDisabled: false,
        cableChannel: false
      }
      const WHITE_LIST_ITEMS = ['macDisabled', 'areaDisabled', 'cableChannel']
      // 关联订单如果售卖方式为：CPD2.计划单中的投放总量为不限量，且不可更改
      if (this.order.sellingType === 3) {
        obj.trafficTypeDisabled = true
      }
      if (this.isAllowEditStatus.indexOf(this.scheduleForm.scheduleStatus) > -1) {
        for (let i in obj) {
          obj[i] = !WHITE_LIST_ITEMS.includes(i)
        }
      }
      if (
        this.scheduleForm.scheduleStatus !== 9 &&
        this.scheduleForm.scheduleStatus !== 4 &&
        this.scheduleForm.scheduleStatus !== 3
      ) {
        obj.frequencyDisabled = false
      }
      if (this.mode === 'edit') {
        obj.autoFillingDisabled = true
      }
      return obj
    },
    subFrequencyDisabled() {
      return [3, 4, 9].includes(this.scheduleForm.scheduleStatus)
    },
    // 尺寸
    sizeData() {
      let text = ''
      if (this.scheduleForm.deviceSizeData !== '-1') {
        const index = this.deviceSizeList.findIndex(
          (item) => item.value === this.scheduleForm.deviceSizeData
        )
        if (index > -1) {
          const ownSize =
            this.scheduleForm.minSize && this.scheduleForm.maxSize
              ? this.scheduleForm.minSize + '-' + this.scheduleForm.maxSize + '寸'
              : ''
          text =
            this.deviceSizeList[index].label === '自定义'
              ? '自定义 ' + ownSize
              : this.deviceSizeList[index].label
        }
      }
      return text
    },
    // // 视频源
    videoData() {
      const text = []
      this.videoSourceList.forEach((item) => {
        this.scheduleForm.videoSource.forEach((element) => {
          if (item.value === element) {
            text.push(item.label)
          }
        })
      })
      return text
    },
    // 品牌数据
    brandData() {
      const text = this.scheduleForm.brandList.map((item) => {
        return item.label
      })
      return text
    },
    // 关联频控的清空按钮禁用状态
    cleanBtnDisabled() {
      return false
    },
    subFreqOptions() {
      switch (this.scheduleForm.frequency) {
        case 3:
        case 4:
        case 6:
          return this.freOptions.filter((item) => [2].includes(item.label))
        case 7:
          return this.freOptions.filter((item) => [2, 6].includes(item.label))
        case 5:
          return this.freOptions.filter((item) => [2, 3, 4, 6, 7].includes(item.label))
        default:
          return []
      }
    },
    dailyTrafficTable() {
      // allTime 投放时间之间所有日期 ['2022-05-11', '2022-05-12', '2022-05-13', '2022-05-14', '2022-05-15']
      const allTime = this.getConsequentDay()
      const payTraffics = getDailyTraffics(this.scheduleForm.payDailyTraffic)
      const freeTraffics = getDailyTraffics(this.scheduleForm.freeDailyTraffic)
      const addedTraffics = getDailyTraffics(this.scheduleForm.addedDailyTraffic)
      return allTime.map((item, index) => {
        const trafficItem = {
          daily: item,
          totalTraffic: '-',
          payTotalTraffic: '-',
          freeTotalTraffic: '-',
          addedTotalTraffic: '-',
          isWeek: this.$moment(item).isoWeekday() > 5
        }
        if (payTraffics.length === allTime.length) {
          trafficItem.payTotalTraffic = payTraffics[index]
        }
        if (freeTraffics.length === allTime.length) {
          trafficItem.freeTotalTraffic = freeTraffics[index]
        }
        if (addedTraffics.length === allTime.length) {
          trafficItem.addedTotalTraffic = addedTraffics[index]
        }
        trafficItem.totalTraffic =
          stringToInt(trafficItem.payTotalTraffic) +
          stringToInt(trafficItem.freeTotalTraffic) +
          stringToInt(trafficItem.addedTotalTraffic)
        return trafficItem
      })
    },
    showCtr() {
      if (!this.scheduleForm.spaceId) return false
      const space = this.spaceOptions.find(
        (option) => option.value === this.scheduleForm.spaceId
      )
      if (!space) return false
      return (
        this.isOwn &&
        space.spaceGuideIconConfig &&
        space.spaceGuideIconConfig.widthLimit > 0
      )
    },
    showExposureDirectly() {
      if (!this.scheduleForm.spaceId) return false
      const space = this.spaceOptions.find(
        (option) => option.value === this.scheduleForm.spaceId
      )
      if (!space) return false
      return space.supportInterestTag === 1
    }
  },
  watch: {
    isHasNewSystem: {
      handler(n, o) {
        if (n) {
          this.scheduleTaUvKpi = [0]
        }
      },
      immediate: true
    },
    'scheduleForm.regionList': {
      handler(newValue, oldValue) {
        this.handleSetScheduleName()
      },
      deep: true
    },
    'scheduleForm.macList': {
      handler(newValue, oldValue) {
        this.formButtonObj.submitAudit.show = this.showOtherDirections
      },
      deep: true
    }
  },
  methods: {
    pvFrequencyChange(e) {},
    clearSpaceHandle(e) {
      this.scheduleForm.taCondition = e.replace(/\s*/g, '') // 去除空格
    },
    uvInputHandle(e) {
      let uvTarget = e.replace(/[^\d]/g, '')
      this.$set(this.scheduleForm, 'uvTarget', uvTarget)
    },
    genScheduleForm() {
      return {
        uvCanSelect: '',
        orderId: this.order.orderId,
        partnerId: this.order.partnerId,
        scheduleName: '',
        scheduleStatus: undefined,
        scheduleId: undefined,
        directPackageSave: 0,
        directPackageName: '',
        planType: 0, // 计划类型
        scheduleSource: undefined, // 程序化来源
        supportMode: undefined, // 程序化类型
        saleType: 1, // 1，正常投放,2，剩余流量投放
        channelId: undefined, // 投放渠道
        payment: undefined,
        seq: 0, // 优先级
        trafficSpeed: undefined, // 投放速度，默认匀速，1快速
        exposureDirectly: 1,
        pvRate: '', // ta浓度曲线
        spaceId: undefined,
        dateType: 0, // 投放时间类型 0：全体投放,1:指定时段
        trafficType: 4, // 投放类型1，不限量,2总共投，3:按天投，4分天投
        totalTraffic: undefined, // 投放量，
        frequency: 1,
        trafficDaily: undefined, // 频次
        homeDeWeight: 0,
        autoFilling: 1,
        customMatchRule: 'in',
        macList: [{ beginMac: undefined, endMac: undefined }],
        seqType: 0,
        putTimeList: [
          {
            timeDay: [],
            pickerOptions: {
              disabledDate: this.disabledDate()
            },
            timeHours: [],
            disabled: false
          }
        ],
        trafficUnit: 0, // 投放量单位,
        payDailyTraffic: '',
        freeDailyTraffic: '',
        addedDailyTraffic: '',
        areaType: 0, // 地区定向类型
        regionList: [], // 地区存储数据
        deviceSizeData: '-1', // 默认尺寸数据
        minSize: undefined,
        maxSize: undefined,
        brandList: [], // 品牌数据
        brandType: 0,
        videoSource: [0],
        customTagType: 0, // 自定义标签
        dmpMatchType: -1, // dmp类型
        policyName: '',
        dmpTags: [], // dmp标签
        macTags: [], // mac包标签
        lbsTags: [], // lbs标签
        businessList: [], // 业务定向
        mediaTags: [], // 媒资标签,
        unionSequence: 0, // 是否关联频控
        unionFreq: undefined, // 关联频控总投放数
        subUnionFreq: undefined, // 关联频控总投放数
        unionFreqCheck: '', // 用于校验频控顺序
        cableChannelList: [], // 媒体方
        subFrequency: 1,
        subTrafficDaily: undefined,
        sellingPrice: 0,
        billType: this.order.sellingType,
        receivePct: 0, // 放量溢出比数值
        checkExposurePct: undefined,
        addExposurePct: undefined,
        exposurePct: undefined,
        extendParams: '',
        ctr: undefined,
        crowdMatchType: -1, // 自定义人群包类型
        crowdList: [], // 自定义人群
        payTraffic: '',
        freeTraffic: '',
        addedTraffic: '',
        isCorrect: 0,
        isFreeCorrect: 0,
        isAddedCorrect: 0,
        erpSubOrder: '',
        erpOrderName: '',
        suborderNo: '',
        dealId: '',
        taStatus: 0,
        uvStatus: 0,
        uvTarget: '',
        uvPercentage: '',
        taCondition: '',
        scheduleTaUvId: '',
        pvRatioType: 0, // 曝光频次占比类型
        uvRateList: [
          {
            uvMatch: 0,
            frequency: '',
            uvPercentage: '',
            minFrequency: '',
            maxFrequency: ''
          }
        ],
        recId: undefined,
        iesSwitch: this.order.iesSwitch || 0
      }
    },
    handleFetch() {
      this.formButtonObj.saveClose.loading = true
      this.formButtonObj.saveAuditAndEditMedia.loading = true
      this.formButtonObj.submitAuditAndEditMedia.loading = true
      this.formButtonObj.submitAudit.loading = true
      this.getScheduleDirect().then(() => {
        this.formButtonObj.saveClose.loading = false
        this.formButtonObj.saveAuditAndEditMedia.loading = false
        this.formButtonObj.submitAuditAndEditMedia.loading = false
        this.formButtonObj.submitAudit.loading = false
        const watch = () => {
          this.$watch('scheduleForm', this.handleWatchScheduleForm, { deep: true })
        }
        if (this.mode === 'create') {
          if (this.order.sellingType === 3) {
            this.scheduleForm.trafficType = 1
          }
          watch()
          this.handleSetScheduleName()
          // 新增显示保存并关闭、保存并添加素材
          this.formButtonObj.saveClose.show = true
          this.formButtonObj.saveAuditAndEditMedia.show = true
          this.handleSetcableChannel()
          this.getSpaceList()
        } else {
          this.scheduleForm.planType = this.editForm.planType
          this.scheduleForm.scheduleSource = this.editForm.scheduleSource
          this.getSpaceList().then((data) => {
            this.editReview().then((res) => {
              this.getCableChannel(false)
              watch()
            })
          })
        }
        this.getThirdDmpList().then((res) => {
          if (this.mode === 'create') {
            this.handleThirdDmp(true)
          } else {
            this.dmpComponentList = this.editForm.thirdDmpEntityList || []
            this.thirdDmpId = this.dmpComponentList.length
              ? this.dmpComponentList[0].dmpId
              : -1
            this.handleThirdDmp()
          }
        })
      })
    },
    handleWatchScheduleForm() {
      this.handleBtnStatus()
    },
    handleBtnStatus() {
      if (this.mode === 'create') {
        if (
          this.scheduleForm.spaceId !== '' &&
          this.scheduleForm.putTimeList.some(
            (item) => item.timeDay && item.timeDay.length
          )
        ) {
          if (this.scheduleForm.trafficType === 2 && this.scheduleForm.totalTraffic > 0) {
            this.formButtonObj.saveAuditAndEditMedia.disabled = false
          } else if (this.scheduleForm.trafficType === 1) {
            this.formButtonObj.saveAuditAndEditMedia.disabled = false
          } else if (
            this.scheduleForm.trafficType === 4 &&
            this.dailyTrafficTable.length > 0
          ) {
            this.formButtonObj.saveAuditAndEditMedia.disabled = false
          } else {
            this.formButtonObj.saveAuditAndEditMedia.disabled = true
          }
        }
      } else {
        this.formButtonObj.submitAudit.disabled = false
      }
    },
    // 获取定向信息
    getScheduleDirect() {
      return new Promise((resolve, reject) => {
        this.$service.getScheduleDirect({ orderId: this.order.orderId }).then((data) => {
          this.directinal = data
          // 需要勾选品牌,并且不能选择不限
          if (this.directinal.isNeedBrands) {
            this.scheduleForm.brandType = 1
          }
          this.scheduleSourceList = JSON.parse(
            JSON.stringify(this.directinal.scheduleSourceList || [])
          )
            .filter(({ bizValue }) => bizValue !== 0)
            .map((item) => {
              return {
                label: item.bizLabel,
                value: item.bizValue,
                supportMode: item.supportMode,
                spaceNoStr: item.adSpaces
              }
            })
          this.saleTypeOptions = JSON.parse(
            JSON.stringify(this.directinal.saleTypeList || [])
          )
            .filter(({ bizValue }) => bizValue !== 0)
            .map((item) => {
              return {
                value: item.bizValue,
                label: item.bizLabel
              }
            })
          this.channelIdList = this.directinal.channelIdList.map((item) => {
            return {
              label: item.channelName,
              value: item.channelId,
              type: item.type,
              allowBrandList: item.brandList ? item.brandList : []
            }
          })
          // 计划类型
          this.planTypeList = (this.directinal.planTypeList || []).map((item) => {
            return {
              label: item.planTypeName,
              value: item.planTypeId
            }
          })
          // 投放渠道赋值
          if (this.channelIdList.length > 0) {
            this.handleSetChannel()
          }
          this.paymentList = this.directinal.paymentList.map((item) => {
            return {
              label: item.dictLabel,
              value: parseInt(item.dictValue)
            }
          })
          // 结算方式赋值
          if (this.paymentList.length > 0) {
            this.handleSetPayment()
          }
          // 优先级过滤小于10
          this.seqList = JSON.parse(JSON.stringify(this.directinal.seqList || []))
            .filter((item) => parseInt(item.dictValue) >= 10)
            .map((item) => {
              return {
                label: item.dictLabel,
                value: parseInt(item.dictValue)
              }
            })
          this.regionsData = buildRegionData(this.directinal.regionList)
          this.deviceSizeList = handleDeviceSize(this.directinal.deviceSizeList)
          this.videoSourceList = this.directinal.videoSourceList
            .filter((item) => item.tag !== 'voole')
            .map((item) => {
              return {
                label: item.tag,
                value: item.tagDeviceId
              }
            })
          this.macTagList = this.directinal.macTagList.map((item) => {
            return {
              label: item.adCustomTagName,
              value: item.adCustomTagId
            }
          })
          this.customTagList = this.directinal.scheduleTagCustomList || []
          this.lbsTagList = this.directinal.lbsTagList.map((item) => {
            return {
              label: item.circleName,
              value: item.tagId
            }
          })
          this.templateList = this.directinal.templateList || []
          resolve(true)
        })
      })
    },
    // 获取广告位信息
    getSpaceList() {
      return new Promise((resolve, reject) => {
        const params = {
          orderId: this.order.orderId,
          planType: this.scheduleForm.planType,
          scheduleSource:
            this.scheduleForm.planType === 0 ? 0 : this.scheduleForm.scheduleSource || 0
        }
        this.$service.getScheduleNeedAdSpace(params).then((data) => {
          this.spaceList = (data || []).map((item) => {
            const space =
              this.directinal.spaceList.find((sp) => sp.spaceId === item.spaceId) || {}
            return {
              ...space,
              label: item.spaceName,
              value: item.spaceId,
              spaceNo: item.spaceNo,
              receivePct: item.receivePct,
              defaultTrafficSpeed: item.defaultTrafficSpeed,
              adSpaceComponentEntityList: item.adSpaceComponentEntityList
            }
          })
          resolve(true)
        })
      })
    },
    // 根据投放渠道/erp素材时长/是否程序化/广告位/尺寸 获取支持的品牌机型
    getBrandList() {
      if (!this.scheduleForm.channelId || !this.spaceNo) {
        return
      }
      const params = {
        channelIds: [this.scheduleForm.channelId],
        mediaTimes: this.scheduleForm.erpSubOrder ? this.mediaTimes : undefined,
        planType: this.scheduleForm.planType,
        sizeTarget: this.scheduleForm.deviceSizeData === '-1' ? 0 : 1,
        spaceNo: this.spaceNo
      }
      return this.$service.getBrandList(params).then((res) => {
        this.brandsModelsList = res || []
      })
    },
    // 切换地区类型
    handleChangeAreaType() {
      this.scheduleForm.regionList = []
      this.customTag = ''
    },
    handleChangePvRatioType() {},
    // 切换品牌
    handleChangeBrandType() {
      this.scheduleForm.brandList = []
      this.clearPackage()
    },
    clearPackage() {
      this.customTag = ''
      this.directPackageId = ''
    },
    // 切换自定义标签
    hanldeChangeCustomTagType() {
      this.scheduleForm.macTags = []
      this.scheduleForm.lbsTags = []
      this.clearPackage()
    },
    // 切换DMP类型
    handleChangeDmpSelectType() {
      this.scheduleForm.policyId = undefined
      this.scheduleForm.policyName = ''
      this.scheduleForm.dmpTags = []
      this.clearPackage()
    },
    // 设置计划名称 不要省、市字样；全国就叫全国；多个地方就叫多地
    handleSetScheduleName() {
      if (!this.isHasManualScheduleName) {
        if (this.scheduleForm.regionList.length === 1) {
          const areaName = this.scheduleForm.regionList[0].label
            .replace('省', '')
            .replace('市', '')
          this.scheduleForm.scheduleName = (this.order.orderName + areaName).substring(
            0,
            44
          )
        } else if (this.scheduleForm.regionList.length > 1) {
          this.scheduleForm.scheduleName = (this.order.orderName + '多地').substring(
            0,
            44
          )
        } else {
          this.scheduleForm.scheduleName = (this.order.orderName + '全国').substring(
            0,
            44
          )
        }
      }
    },
    // 修改计划类型，二次确认
    handleChangePlanType(val) {
      if (this.mode === 'edit' && !this.triggerDialogFormStatus.planTypeChange) {
        this.$confirm('修改后计划单下的素材将被清空，是否确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.triggerDialogFormStatus.planTypeChange = true
            this.scheduleForm.scheduleSource = 0
            this.getSpaceList()
            this.getCableChannel()
            this.dealIdType = 0
            this.scheduleForm.dealId = ''
            this.scheduleForm.brandList = []
            this.getBrandList()
          })
          .catch(() => {
            this.scheduleForm.planType = val === 0 ? 1 : 0
            this.triggerDialogFormStatus.planTypeChange = true
          })
      } else {
        this.scheduleForm.scheduleSource = 0
        this.getSpaceList()
        this.getCableChannel()
        this.dealIdType = 0
        this.scheduleForm.dealId = ''
        this.scheduleForm.brandList = []
        this.getBrandList()
      }
    },
    // 修改程序化来源二次确认
    handleChangeScheduleSource(val) {
      if (this.mode === 'edit' && !this.triggerDialogFormStatus.scheduleSourceChange) {
        this.$confirm('修改后计划单下的素材将被清空，是否确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.handleSetScheduleSource(val)
            this.triggerDialogFormStatus.scheduleSourceChange = true
          })
          .catch(() => {
            this.triggerDialogFormStatus.scheduleSourceChange = true
          })
      } else {
        this.handleSetScheduleSource(val)
      }
    },
    // 程序化来源赋值
    handleSetScheduleSource(val) {
      this.scheduleForm.scheduleSource = val
      // 程序化来源发生变化时，需要清空广告位
      this.getSpaceList()
      this.scheduleForm.spaceId = undefined
      this.scheduleForm.supportMode = undefined
      const isSelectScheduleSourceList = this.scheduleSourceList.filter(
        (item) => item.value === this.scheduleForm.scheduleSource
      )
      if (isSelectScheduleSourceList.length > 0) {
        if (this.scheduleForm.supportMode === undefined) {
          this.scheduleForm.supportMode = parseInt(
            isSelectScheduleSourceList[0].supportMode.split(',')[0]
          )
        }
      }
      this.$refs.scheduleForm.validateField('scheduleSource')
    },
    // 修改程序化类型二次确认
    handleChangeSupportMode(val) {
      if (this.mode === 'edit' && !this.triggerDialogFormStatus.scheduleSourceChange) {
        this.$confirm('修改后计划单下的素材将被清空，是否确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.scheduleForm.supportMode = val
            this.triggerDialogFormStatus.scheduleSourceChange = true
          })
          .catch(() => {
            this.triggerDialogFormStatus.scheduleSourceChange = true
          })
      }
    },
    // 投放渠道更改
    handleChangeChannel() {
      // 切换投放渠道，需要清空重新获取品牌机型
      this.scheduleForm.brandList = []
      this.getBrandList()
      if (this.directinal.isNeedBrands) {
        this.scheduleForm.brandType = 1
      } else {
        this.scheduleForm.brandType = 0
      }
      this.handleChangeAllDirection()
      // 处理默认勾选媒体方
      this.scheduleForm.cableChannelList = []
      this.getCableChannel()
      // 切换为自有渠道(即老系统)清空广告位，切换为新系统不清空
      if (this.isOwn) {
        this.getSpaceList()
        this.scheduleForm.spaceId = undefined
        this.scheduleForm.trafficSpeed = undefined
        this.scheduleForm.exposureDirectly = 1
        this.ctrType = 0
        this.scheduleForm.ctr = undefined
      } else {
        this.scheduleForm.trafficSpeed = 2
      }
    },
    handleSetcableChannel() {
      this.scheduleForm.cableChannelList = this.cableChannelList
        .filter((item) => item.selectBox === 1)
        .map((item) => item.value)
    },
    // 切换投放渠道，修改定向信息
    handleChangeAllDirection() {
      // 重新获取定向包选项
      this.directPackageId = ''
      this.getDirectPackages()
      // fix 复制的计划单，编辑改变投放渠道为非自有，要重置关联频控
      this.scheduleForm.unionSequence = 0
      this.scheduleForm.unionFreq = undefined
      this.scheduleForm.subUnionFreq = undefined
      this.selectTable.data = []
      // 选择非自有时
      if (!this.isOwn) {
        // 非自有不允许整周和整月投放
        if (this.scheduleForm.frequency === 3 || this.scheduleForm.frequency === 4) {
          this.scheduleForm.frequency = 1
          this.scheduleForm.trafficDaily = undefined
        }
        // 非自有，家庭默认否
        this.scheduleForm.homeDeWeight = 0
        // 非自有，不能定投mac
        this.scheduleForm.macList = [{ beginMac: undefined, endMac: undefined }]
        // 非自有，不能选50以下尺寸
        this.deviceSizeList = this.deviceSizeList.filter((item) => item.value !== '0-49')
        if (this.scheduleForm.deviceSizeData === '0-49') {
          this.scheduleForm.deviceSizeData = '-1'
        }
        // 非自有，不能定投视频源
        this.scheduleForm.videoSource = [0]
        // 非自有，不能定投自定义标签、dmp人群、人群包
        this.scheduleForm.customTagType = 0
        this.scheduleForm.dmpMatchType = -1
        this.scheduleForm.crowdMatchType = -1
        this.scheduleForm.crowdList = []
        this.scheduleForm.customMatchRule = 'in'
        this.scheduleForm.macTags = []
        this.scheduleForm.lbsTags = []
        this.scheduleForm.policyId = undefined
        this.scheduleForm.policyName = ''
        this.scheduleForm.dmpTags = []
      } else {
        this.deviceSizeList = handleDeviceSize(this.directinal.deviceSizeList)
      }
    },
    getDirectPackages() {
      if (!this.scheduleForm.channelId || !this.scheduleForm.spaceId) {
        return
      }
      const params = {
        channelId: this.scheduleForm.channelId,
        spaceId: this.scheduleForm.spaceId
      }
      this.$service.getDirectPackages(params).then((res) => {
        this.directPackageOpts = res || []
      })
    },
    handleSetChannel() {
      if (
        this.scheduleForm.channelId === undefined ||
        this.scheduleForm.channelId === ''
      ) {
        this.scheduleForm.channelId = this.channelIdList[0].value
      }
    },
    handleSetPayment() {
      if (this.scheduleForm.payment === undefined || this.scheduleForm.payment === '') {
        this.scheduleForm.payment = this.paymentList[0].value
      }
    },
    handleKpiCable(value) {
      const index = this.scheduleTaUvKpi.findIndex((item) => item === 0)
      const length = this.scheduleTaUvKpi.length
      if ((index === 0 && length < 1) || index === length - 1) {
        this.scheduleTaUvKpi = [0]
      } else {
        this.scheduleTaUvKpi = this.scheduleTaUvKpi.filter((item) => item !== 0)
      }
      if (!value.includes('N+UV')) {
        this.scheduleForm.uvTarget = ''
        this.scheduleForm.uvPercentage = ''
      }
      if (!value.includes('TA')) {
        this.scheduleForm.taCondition = ''
      }
    },
    handleCheckedCable(value) {
      if (!this.cableCheckable && value.indexOf('IQIYI') > -1) {
        this.scheduleForm.cableChannelList = value.filter((item) => item !== 'IQIYI')
        return this.$message.error('客户账号未通过爱奇艺审核')
      }
    },
    // 优先级更改
    handleChangeSeq() {
      if (this.scheduleForm.seqType === 0) {
        this.scheduleForm.seq = 0
      } else {
        this.scheduleForm.seq = this.seqList[0].value
      }
    },
    handleChangeExtendType() {
      if (this.extendParamType === 0) {
        this.extendParamList = []
        this.template = ''
      }
    },
    // 时间相关函数处理
    handleChangeDateType() {
      this.scheduleForm.putTimeList.forEach((element) => {
        element.timeHours =
          this.scheduleForm.dateType === 0 ? [] : ['00:00:00', '23:59:59']
      })
    },
    // 添加时间，如果有空的时间，则不允许添加
    handleAddTimePicker(formName) {
      this.scheduleForm.putTimeList.push({
        timeDay: [],
        pickerOptions: {
          disabledDate: this.disabledDate(this.scheduleForm.putTimeList.length)
        },
        timeHours: this.scheduleForm.dateType === 0 ? [] : ['00:00:00', '23:59:59'],
        disabled: false
      })
    },
    // 删除投放时间
    handleDeleteTimePicker(index) {
      // 当只有一个投放日期时，删除相当于清空
      if (this.scheduleForm.putTimeList.length === 1) {
        this.scheduleForm.putTimeList.timeDay = []
        this.scheduleForm.putTimeList.timeHours = []
        this.scheduleForm.putTimeList.disabled = false
      } else {
        this.scheduleForm.putTimeList.splice(index, 1)
      }
      if (this.scheduleForm.trafficType === 4) {
        this.handleChangeDailyTraffic()
      }
    },
    // 投放时间变化
    handleInputPutTime(index, val) {
      if (this.mode === 'create') {
        this.$set(this.scheduleForm.putTimeList[index], 'timeDay', val)
      } else {
        if (this.isAllowEditStatus.indexOf(this.scheduleForm.scheduleStatus) > -1) {
          if (this.scheduleForm.putTimeList[index].timeDay.length) {
            const oldBeginTime = new Date(
              this.scheduleForm.putTimeList[index].timeDay[0]
            ).getTime() // 旧的开始时间
            const oldEndTime = new Date(
              this.scheduleForm.putTimeList[index].timeDay[1]
            ).getTime() // 旧的结束时间
            const nowTime = new Date(this.$moment().format('YYYY-MM-DD')).getTime() // 当前时间
            // 日期一部分过去一部分还未到，所以不可删除，但能修改截止日期，截止日期必须≥当日；
            if (oldBeginTime < nowTime && oldEndTime > nowTime) {
              if (!val) {
              } else {
                const time = [this.scheduleForm.putTimeList[index].timeDay[0], val[1]]
                this.$set(this.scheduleForm.putTimeList[index], 'timeDay', time)
              }
            } else {
              this.$set(this.scheduleForm.putTimeList[index], 'timeDay', val)
            }
          } else {
            this.$set(this.scheduleForm.putTimeList[index], 'timeDay', val)
          }
        } else {
          this.$set(this.scheduleForm.putTimeList[index], 'timeDay', val)
        }
      }
      if (this.scheduleForm.trafficType === 4) {
        this.handleChangeDailyTraffic()
      }
    },
    // 总共投，修改了排期总量，校验其他两项
    handlePayTrafficChange(val) {
      this.$refs.scheduleForm.validateField('freeTraffic')
      this.$refs.scheduleForm.validateField('addedTraffic')
    },
    // 总共投，修改了赠送总量，校验其他两项
    handleFreeTrafficChange(val) {
      if (this.payTrafficDisabled) {
        return
      }
      this.$refs.scheduleForm.validateField('payTraffic')
      this.$refs.scheduleForm.validateField('addedTraffic')
    },
    // 总共投，修改了补量总量，校验其他两项
    handleAddedTrafficChange(val) {
      this.$refs.scheduleForm.validateField('payTraffic')
      this.$refs.scheduleForm.validateField('freeTraffic')
    },
    // 投放日期组件禁止选择时间
    disabledDate() {
      return (time) => {
        // 计划单的开始时间需要在订单开始时间内，如果订单开始 < 当前，取当前，否则取订单开始时间
        // 计划单的结束时间，需要在订单结束时间内
        const cur = this.$moment(new Date()).format('YYYY-MM-DD 00:00:00')
        const minStartTime = this.$moment(this.order.contractBeginDate).isSameOrBefore(
          cur
        )
          ? Date.now() - 8.64e7
          : this.order.contractBeginDate

        const endTime = this.order.contractEndDate
        const startTime = minStartTime
        if (time.getTime() < startTime || time.getTime() > endTime) {
          return true
        }
      }
    },
    // 重置每日排期量和每日赠送量
    resetDailyTraffic() {
      this.scheduleForm.payTraffic = ''
      this.scheduleForm.freeTraffic = ''
      this.scheduleForm.addedTraffic = ''
      this.scheduleForm.payDailyTraffic = ''
      this.scheduleForm.freeDailyTraffic = ''
      this.scheduleForm.addedDailyTraffic = ''
      this.oldPayTraffics = []
      this.oldFreeTraffics = []
      this.oldAddedTraffics = []
    },
    // 输入投放总量, 校验每日排期量
    handleChangeTotalTraffic() {
      if (this.scheduleForm.trafficType === 2) {
        this.scheduleForm.payTraffic &&
          this.$refs.scheduleForm.validateField('payTraffic')
        this.scheduleForm.freeTraffic &&
          this.$refs.scheduleForm.validateField('freeTraffic')
        this.scheduleForm.addedTraffic &&
          this.$refs.scheduleForm.validateField('addedTraffic')
      } else if (this.scheduleForm.trafficType === 4) {
        this.handleChangeDailyTraffic()
      }
    },
    // 修改投放总量类型 1不限量2总共投4分天投
    handleChangeTrafficType() {
      // 投放总量单位重置为CPM
      this.scheduleForm.trafficUnit = 0
      if (this.scheduleForm.trafficType === 1) {
        this.scheduleForm.totalTraffic = undefined
        this.$refs.scheduleForm.validateField('totalTraffic')
      }
      this.resetDailyTraffic()
    },
    handleChangeDailyTraffic() {
      this.validateDailyTraffic('pay')
      this.validateDailyTraffic('free')
      this.validateDailyTraffic('added')
    },
    // 输入每天的投放量
    validateDailyTraffic(type) {
      this.validatingTraffic = true
      const payTraffics = getDailyTraffics(this.scheduleForm.payDailyTraffic)
      const freeTraffics = getDailyTraffics(this.scheduleForm.freeDailyTraffic)
      const addedTraffics = getDailyTraffics(this.scheduleForm.addedDailyTraffic)
      if (type === 'pay') {
        this.scheduleForm.isCorrect = 0
      } else if (type === 'free') {
        this.scheduleForm.isFreeCorrect = 0
      } else if (type === 'added') {
        this.scheduleForm.isAddedCorrect = 0
      }
      if (type === 'pay' && payTraffics.length !== 0) {
        if (payTraffics.some((item) => item.indexOf('.') > -1)) {
          this.scheduleForm.isCorrect = 4
          return
        }
        let errorCode = this.checkDailyTraffic(payTraffics, this.oldPayTraffics)
        if (errorCode !== 0) {
          this.scheduleForm.isCorrect = errorCode
          return
        }
      }
      if (type === 'free' && freeTraffics.length !== 0) {
        if (freeTraffics.some((item) => item.indexOf('.') > -1)) {
          this.scheduleForm.isFreeCorrect = 4
          return
        }
        let errorCode = this.checkDailyTraffic(freeTraffics, this.oldFreeTraffics)
        if (errorCode !== 0) {
          this.scheduleForm.isFreeCorrect = errorCode
          return
        }
      }
      if (type === 'added' && addedTraffics.length !== 0) {
        if (addedTraffics.some((item) => item.indexOf('.') > -1)) {
          this.scheduleForm.isAddedCorrect = 4
          return
        }
        let errorCode = this.checkDailyTraffic(addedTraffics, this.oldAddedTraffics)
        if (errorCode !== 0) {
          this.scheduleForm.isAddedCorrect = errorCode
          return
        }
      }

      const payCount = payTraffics.reduce((prev, cur) => {
        return prev + (cur ? parseInt(cur) : 0)
      }, 0)
      const freeCount = freeTraffics.reduce((prev, cur) => {
        return prev + (cur ? parseInt(cur) : 0)
      }, 0)
      const addedCount = addedTraffics.reduce((prev, cur) => {
        return prev + (cur ? parseInt(cur) : 0)
      }, 0)

      // 复制的计划单(草稿状态)编辑，如果有排期量需要绑定erp订单
      if (
        ((this.erpModeSwitch === 1 && !this.scheduleForm.erpSubOrder) ||
          (this.erpModeSwitch === 2 && !this.scheduleForm.suborderNo)) &&
        this.scheduleForm.scheduleStatus === 1 &&
        payCount > 0
      ) {
        this.scheduleForm.isCorrect = 6
        return
      }
      // 投放总量不可更改时计算投放总量
      if (this.mode === 'edit' && this.disableForm.trafficTypeDisabled) {
        this.scheduleForm.totalTraffic = payCount + freeCount + addedCount
      }
      const totalTraffic = this.scheduleForm.totalTraffic
        ? parseInt(this.scheduleForm.totalTraffic)
        : 0
      const isTrafficCorrect = payCount + freeCount + addedCount === totalTraffic
      if (type === 'pay' && !isTrafficCorrect) {
        this.scheduleForm.isCorrect = 3
      }
      if (type === 'free' && !isTrafficCorrect) {
        this.scheduleForm.isFreeCorrect = 3
      }
      if (type === 'added' && !isTrafficCorrect) {
        this.scheduleForm.isAddedCorrect = 3
      }
      this.$refs.scheduleForm.validateField('isCorrect')
      this.$refs.scheduleForm.validateField('isFreeCorrect')
      this.$refs.scheduleForm.validateField('isAddedCorrect')
    },
    checkDailyTraffic(trafficList, oldTrafficList = []) {
      const allDays = this.getConsequentDay()
      const putDays = this.getPutDay()
      let errorCodes = []
      if (allDays.length !== trafficList.length) {
        return 1
      }

      for (let i = 0; i < allDays.length; i++) {
        if (putDays.some((day) => day === allDays[i])) {
          const current = new Date(this.$moment().format('YYYY-MM-DD')).getTime()
          const day = new Date(this.$moment(allDays[i]).format('YYYY-MM-DD')).getTime()
          const oldDailyTraffic = oldTrafficList[i] ? oldTrafficList[i].totalTraffic : 0

          if (trafficList[i] >= 0) {
            if (day < current && trafficList[i] < oldDailyTraffic) {
              errorCodes.push(2)
            }
          } else {
            errorCodes.push(1)
          }
        } else {
          trafficList[i] > 0 && errorCodes.push(1)
        }
      }

      return errorCodes.length ? errorCodes[0] : 0
    },
    // 编辑每天的投放量按钮
    editDailyTraffic() {
      this.dailyTrafficDisabled = false
    },
    // 获取投放日期
    getPutDay() {
      let dayList = []
      this.scheduleForm.putTimeList.forEach((item) => {
        if (item.timeDay && item.timeDay[0] && item.timeDay[1]) {
          const timeBettween = getBetweenDate(item.timeDay[0], item.timeDay[1])
          dayList = dayList.concat(timeBettween)
        }
      })
      // dayList 投放日期 ['2022-05-11', '2022-05-12', '2022-05-15']
      dayList.sort((a, b) => {
        return new Date(b).getTime() - new Date(a).getTime()
      })
      if (dayList.length === 0) {
        return []
      }
      return dayList
    },
    // 获取连续的投放日期
    getConsequentDay() {
      const continuousTimeList = this.getPutDay()
      if (continuousTimeList.length === 0) {
        return []
      }
      let minDate = continuousTimeList[continuousTimeList.length - 1]
      let maxDate = continuousTimeList[0]
      return getBetweenDate(minDate, maxDate)
    },
    handleDisableTime(time, status) {
      if (this.isAllowEditStatus.indexOf(status) > -1) {
        const currDate = new Date(this.$moment(new Date()).format('YYYY-MM-DD 00:00:00'))
        if (new Date(time).getTime() >= currDate.getTime()) {
          return false
        } else {
          return true
        }
      }
    },
    // 选择了dmp策略
    handleDmpSelect(rowData) {
      this.scheduleForm.policyId = rowData.policyId
      this.scheduleForm.policyName = rowData.policyName
      this.scheduleForm.dmpTags = []
      this.getCrowdList(rowData.policyId)
      this.clearPackage()
    },
    // 根据策略id获取人群标签
    getCrowdList(policyId) {
      return new Promise((resolve, reject) => {
        if (!policyId) {
          this.dmpTagList = []
          resolve()
        }
        this.$service.getCrowdList({ policyId: policyId }).then((res) => {
          this.dmpTagList = (res || []).map((item) => {
            return {
              label: item.text,
              value: item.crowdId
            }
          })
          resolve()
        })
      })
    },
    // 尺寸定向
    handleChangeSize(val) {
      this.scheduleForm.minSize = undefined
      this.scheduleForm.maxSize = undefined
      this.clearPackage()
      // 尺寸从不限改为其他，或其他改为不限，重新查询品牌
      if (
        (this.backupSize === '-1' && val !== '-1') ||
        (this.backupSize !== '-1' && val === '-1')
      ) {
        this.scheduleForm.brandList = []
        this.getBrandList()
      }
      this.backupSize = val
    },
    handleChangeVideoSource() {
      const index = this.scheduleForm.videoSource.findIndex((item) => item === 0)
      const length = this.scheduleForm.videoSource.length
      if ((index === 0 && length < 1) || index === length - 1) {
        this.scheduleForm.videoSource = [0]
      } else {
        this.scheduleForm.videoSource = this.scheduleForm.videoSource.filter(
          (item) => item !== 0
        )
      }
      this.clearPackage()
    },
    handleInputChangeTemplate(val) {
      this.template = val
      if (val === 'none') {
        this.extendParamList = [{ key: '', value: '' }]
      } else {
        const templateParam = this.templateList.find((item) => item.templateId === val)
        const templateArr = JSON.parse(templateParam.paramsJson)
        this.extendParamList = (templateArr || []).map((item) => {
          return {
            key: item.key,
            value: item.defaultValue,
            name: item.name,
            holder: item.holder
          }
        })
      }
    },
    // 切换广告位
    handleInputChangeSpace(val) {
      if (this.mode === 'edit' && !this.triggerDialogFormStatus.spaceIdChange) {
        this.$confirm('修改后计划单下的素材将被清空，是否确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.handelChangeSpaceImpact(val)
            this.triggerDialogFormStatus.spaceIdChange = true
          })
          .catch(() => {
            this.triggerDialogFormStatus.spaceIdChange = true
          })
      } else {
        this.handelChangeSpaceImpact(val)
      }
    },
    // 切换广告位影响
    handelChangeSpaceImpact(val) {
      this.scheduleForm.spaceId = val
      const space = this.spaceList.filter(
        (item) => item.value === this.scheduleForm.spaceId
      )[0]
      this.spaceNo = space.spaceNo
      // 选中广告位后，如果是程序化则取广告位的pdb溢出比
      if (this.scheduleForm.planType === 1) {
        this.spacePctRatio = space.receivePct
        this.scheduleForm.receivePct = space.receivePct
      }
      this.scheduleForm.recId = undefined
      if (this.spaceNo === 'CCADTV10036' && this.recStreamOptions.length === 0) {
        this.getRecStreamList()
      }
      if (this.spaceNo === 'CCADTV10004') {
        this.getMediaTags().then((data) => {
          this.mediaTagList = data
        })
      } else {
        this.mediaTagList = []
        this.scheduleForm.mediaTags = []
      }
      this.scheduleForm.brandList = []
      this.getBrandList()
      // 切换广告位重置定向包选项
      this.directPackageId = ''
      this.getDirectPackages()
      // 投放速度默认取广告位配置的
      this.scheduleForm.trafficSpeed = this.isOwn ? space.defaultTrafficSpeed : 2
      this.scheduleForm.businessList = []
      this.getCableChannel()
      this.handleBusiness(true)
    },
    handleBusiness(isSetDefault) {
      if (this.spaceList.some((item) => item.value === this.scheduleForm.spaceId)) {
        const { setBusinessComponents } = useSpaceComponent()
        const adSpaceComponentEntityList = this.spaceList.find(
          (item) => item.value === this.scheduleForm.spaceId
        ).adSpaceComponentEntityList
        this.scheduleForm.businessList = setBusinessComponents(
          adSpaceComponentEntityList,
          this.scheduleForm.businessList,
          isSetDefault
        )
      }
    },
    // 三方dmp组件
    handleThirdDmp(isSetDefault) {
      if (this.thirdDmpId === -1) {
        this.dmpComponentList = []
      }
      const { setBusinessComponents } = useSpaceComponent()
      const thirdDmp = this.thirdDmpOptions.find((item) => item.dmpId === this.thirdDmpId)
      const dmpComponents = thirdDmp ? thirdDmp.dmpComponentList : []
      dmpComponents.sort((prev, next) => {
        return prev.componentSeq - next.componentSeq
      })
      this.dmpComponentList = setBusinessComponents(
        dmpComponents,
        this.dmpComponentList,
        isSetDefault
      )
    },
    // 获取媒资标签
    getMediaTags() {
      return new Promise((resolve, reject) => {
        this.$service.getMediaTags().then((data) => {
          resolve(data)
        })
      })
    },
    // 是否手动更改计划名称
    handleManualScheduleName() {
      this.isHasManualScheduleName = true
    },
    // 编辑回显
    editReview() {
      // 编辑页面同步按钮显示状态
      return new Promise((resolve, reject) => {
        if (this.isAllowEditStatus.indexOf(this.editForm.scheduleStatus) > -1) {
          this.formButtonObj.submitAuditAndEditMedia.show = true
          this.formButtonObj.submitAudit.show = true
        } else {
          this.formButtonObj.saveClose.show = true
          this.formButtonObj.saveAuditAndEditMedia.show = true
          this.formButtonObj.saveAuditAndEditMedia.disabled = false
        }
        if (this.editForm.erpSubOrderModel) {
          let erpOrder = this.editForm.erpSubOrderModel
          this.scheduleForm.erpSubOrder = erpOrder.subOrder
          this.scheduleForm.erpOrderName = erpOrder.subOrderName
          this.mediaTimes = erpOrder.materialEntity
            ? parseInt(erpOrder.materialEntity.showTime)
            : undefined
          this.supportedSpaceNos = erpOrder.materialEntity.spaceNo
            ? erpOrder.materialEntity.spaceNo.split(',')
            : []
        }
        // 数据处理
        this.scheduleForm.suborderNo = this.editForm.suborderNo
        this.scheduleForm.sellingPrice = this.editForm.sellingPrice
        this.scheduleForm.scheduleId = this.editForm.scheduleId
        this.scheduleForm.scheduleNo = this.editForm.scheduleNo
        this.scheduleForm.supportMode = this.editForm.supportMode
        this.scheduleForm.saleType = this.editForm.saleType
        this.scheduleForm.channelId = this.editForm.channelId
        this.scheduleForm.payment = this.editForm.payment
        this.scheduleForm.seq = this.editForm.seq
        this.scheduleForm.ctr = this.editForm.ctr
        this.scheduleForm.iesSwitch = this.editForm.iesSwitch
        this.ctrType = this.editForm.ctr ? 1 : 0
        // N+UV
        if (this.editForm.scheduleTaUv) {
          this.scheduleForm.taStatus = this.editForm.scheduleTaUv.taStatus
          this.scheduleForm.uvStatus = this.editForm.scheduleTaUv.uvStatus
          this.scheduleForm.uvTarget = this.editForm.scheduleTaUv.uvTarget || ''
          this.scheduleForm.uvPercentage = this.editForm.scheduleTaUv.uvPercentage || ''
          this.scheduleForm.taCondition = this.editForm.scheduleTaUv.taCondition
          this.scheduleForm.scheduleTaUvId = this.editForm.scheduleTaUv.scheduleTaUvId
          this.scheduleForm.crowdTagId = this.editForm.scheduleTaUv.crowdTagId
          this.scheduleTaUvKpi = []
          if (this.scheduleForm.uvStatus === 1) {
            this.scheduleTaUvKpi.push('N+UV')
          }
          if (this.scheduleForm.taStatus === 1) {
            this.scheduleTaUvKpi.push('TA')
          }
          this.scheduleTaUvKpi = this.scheduleTaUvKpi.length ? this.scheduleTaUvKpi : [0]
        }
        if (this.editForm.uvRateList && this.editForm.uvRateList.length) {
          this.scheduleForm.pvRatioType = 1
          this.scheduleForm.uvRateList = this.editForm.uvRateList.map((item) => {
            return {
              maxFrequency: item.uvMatch === 0 ? '' : item.maxFrequency,
              minFrequency: item.uvMatch === 0 ? '' : item.minFrequency,
              uvMatch: item.uvMatch,
              frequency: item.uvMatch === 0 ? item.maxFrequency : '',
              uvPercentage: item.uvPercentage
            }
          })
        } else {
          this.scheduleForm.pvRatioType = 0
        }
        if (this.editForm.planType === 1 && this.editForm.dealId) {
          this.dealIdType = this.editForm.dealId === this.editForm.scheduleNo ? 0 : 1
          this.scheduleForm.dealId = this.editForm.dealId
        }
        if (this.scheduleForm.seq > 9) {
          this.scheduleForm.seqType = 1
        } else {
          this.scheduleForm.seqType = 0
        }
        if (this.editForm.extendParamsList && this.editForm.extendParamsList.length > 0) {
          const extendParam = JSON.parse(this.editForm.extendParamsList[0].extendParams)
          if (extendParam) {
            this.extendParamType = 1
            const paramsArray = extendParam.paramsArray
            this.template = extendParam.template
            if (this.template !== 'none') {
              const param = this.templateList.find(
                (item) => item.templateId === this.template
              )
              const templateArr = JSON.parse(param.paramsJson)
              const res = templateArr.reduce((result, item) => {
                result[item.key] = item.name
                return result
              }, {})
              this.extendParamList = paramsArray.map((item) => {
                return {
                  key: item.key,
                  value: item.value,
                  name: res[item.key]
                }
              })
            } else {
              this.extendParamList = paramsArray
            }
          }
        }
        this.scheduleForm.trafficSpeed = this.editForm.trafficSpeed
        this.scheduleForm.exposureDirectly = this.editForm.scheduleSub
          ? this.editForm.scheduleSub.exposureDirectly
          : 1
        this.pvRateType = this.editForm.pvRate && this.editForm.pvRate !== '0' ? 1 : 0
        this.scheduleForm.pvRate =
          this.editForm.pvRate && this.editForm.pvRate !== '0' ? this.editForm.pvRate : ''
        this.scheduleForm.spaceId = this.editForm.spaceId
        let space = this.spaceList.find(
          (item) => item.value === this.scheduleForm.spaceId
        )
        if (space) {
          this.spacePctRatio = space.receivePct
          this.spaceNo = space.spaceNo
        }
        this.scheduleForm.receivePct = this.editForm.receivePct
        this.receivePctType = this.editForm.receivePct === this.spacePctRatio ? 0 : 1
        this.exposurePctType = this.editForm.exposurePct ? 1 : 0
        this.scheduleForm.exposurePct = this.editForm.exposurePct
          ? this.editForm.exposurePct
          : undefined
        if (this.editForm.scheduleSub) {
          this.scheduleForm.checkExposurePct =
            this.editForm.scheduleSub.checkExposurePct || this.editForm.exposurePct
          this.scheduleForm.addExposurePct = this.editForm.scheduleSub.addExposurePct
          if (this.editForm.scheduleSub.checkExposurePct > 0) {
            this.exposurePctType = 2
          }
        }

        this.scheduleForm.dateType = this.editForm.dateType
        this.scheduleForm.putTimeList = this.editForm.timeList.map((item, index) => {
          return {
            timeDay: [item.beginTime.split(' ')[0], item.endTime.split(' ')[0]],
            timeHours: [item.beginTime.split(' ')[1], item.endTime.split(' ')[1]],
            pickerOptions: {
              disabledDate: this.disabledDate(index) // 设置日期选择器的禁止时间
            },
            disabled: this.handleDisableTime(item.endTime, this.editForm.scheduleStatus)
          }
        })
        this.scheduleForm.trafficType = this.editForm.trafficType
        // 分天投，只能投cpm
        if (this.scheduleForm.trafficType === 4) {
          this.scheduleForm.totalTraffic = this.editForm.totalTraffic / 1000
          // 每日计划量
          this.scheduleForm.payDailyTraffic = getReviewDailyTraffic(
            this.editForm.payDailyTraffics
          )
          this.scheduleForm.freeDailyTraffic = getReviewDailyTraffic(
            this.editForm.freeDailyTraffics
          )
          this.scheduleForm.addedDailyTraffic = getReviewDailyTraffic(
            this.editForm.addedDailyTraffics
          )
          this.oldPayTraffics = this.editForm.payDailyTraffics || []
          this.oldFreeTraffics = this.editForm.freeDailyTraffics || []
          this.oldAddedTraffics = this.editForm.addedDailyTraffics || []
          this.oldPayTraffics
            .sort((prev, cur) => prev.daily - cur.daily)
            .map((item) => item.totalTraffic)
          this.oldFreeTraffics
            .sort((prev, cur) => prev.daily - cur.daily)
            .map((item) => item.totalTraffic)
          this.oldAddedTraffics
            .sort((prev, cur) => prev.daily - cur.daily)
            .map((item) => item.totalTraffic)
        } else {
          this.scheduleForm.trafficUnit = 0
          this.scheduleForm.totalTraffic = this.editForm.totalTraffic / 1000 || undefined
          // 历史的单排期总量 = 投放总量
          this.scheduleForm.payTraffic =
            this.editForm.payTotalTraffic === undefined
              ? this.editForm.totalTraffic / 1000
              : this.editForm.payTotalTraffic / 1000 || ''
          this.scheduleForm.freeTraffic = this.editForm.freeTotalTraffic / 1000 || ''
          this.scheduleForm.addedTraffic = this.editForm.addedTotalTraffic / 1000 || ''
        }
        this.scheduleForm.scheduleStatus = this.editForm.scheduleStatus
        this.showEditDailyTrafficBtn = true
        this.scheduleForm.frequency = this.editForm.frequency
        this.scheduleForm.trafficDaily =
          this.editForm.frequency === 1 ? undefined : this.editForm.trafficDaily
        this.scheduleForm.subFrequency = this.editForm.subFrequency
        this.scheduleForm.subTrafficDaily =
          this.editForm.subFrequency === 1 ? undefined : this.editForm.subTrafficDaily
        this.scheduleForm.homeDeWeight = this.editForm.homeDeWeight
        this.scheduleForm.autoFilling = this.editForm.autoFilling
        this.scheduleForm.scheduleName = this.editForm.scheduleName
        this.isHasManualScheduleName = true
        this.scheduleForm.macList = this.editForm.adScheduleMacs.map((item) => {
          return {
            beginMac: item.beginMac,
            endMac: item.endMac
          }
        })
        if (this.scheduleForm.macList.length === 0) {
          this.scheduleForm.macList.push({
            beginMac: undefined,
            endMac: undefined
          })
        }
        this.scheduleForm.regionList = handleReviewRegion(
          this.regionsData,
          this.editForm.adScheduleRegions
        )
        if (this.scheduleForm.regionList.length > 0) {
          this.scheduleForm.areaType = 1
        } else {
          this.scheduleForm.areaType = 0
        }
        // 在定向包内的定向，编辑回显
        this.renderDirectPackage(this.editForm)

        this.selectTable.data = (this.editForm.scheduleUnionList || []).map((item) => {
          return {
            unionSeq: item.unionSeq,
            scheduleNo: item.scheduleNo,
            scheduleName: item.scheduleName,
            scheduleStatus: item.scheduleStatus,
            trafficDaily: item.trafficDaily,
            frequency: item.frequency,
            subTrafficDaily: item.subTrafficDaily,
            subFrequency: item.subFrequency,
            scheduleId: item.scheduleId,
            disabled: this.scheduleForm.scheduleId === item.scheduleId,
            seqDisabled: this.editForm.unionSequence === 2 //  选择的如果已经有关联频控，且有顺序，也不能改
          }
        })
        this.scheduleForm.unionSequence = this.editForm.unionSequence || 0
        this.unSeqDisabled = this.editForm.unionSequence === 1
        this.inSeqDisabled = this.editForm.unionSequence === 2
        this.scheduleForm.unionFreq = this.editForm.unionFreq
        this.scheduleForm.subUnionFreq = this.editForm.subUnionFreq
        this.scheduleForm.cableChannelList = (
          this.editForm.adScheduleCableChannels || []
        ).map((item) => item.cableNo)

        if (this.spaceNo === 'CCADTV10036') {
          if (this.recStreamOptions.length === 0) {
            this.getRecStreamList()
          }
          this.scheduleForm.recId =
            this.editForm.scheduleSub && this.editForm.scheduleSub.recId !== 0
              ? this.editForm.scheduleSub.recId
              : undefined
        }

        if (this.spaceNo === 'CCADTV10004') {
          this.getMediaTags().then((data) => {
            this.scheduleForm.mediaTags = handleReviewMedia(
              data,
              this.editForm.adScheduleVideoTags
            )
            this.mediaTagList = data
            this.handleSetOldForm()
          })
        } else {
          this.handleSetOldForm()
        }
        this.$refs.scheduleForm && this.$refs.scheduleForm.clearValidate()
        this.getDirectPackages()
        // 初始化加载完毕
        resolve(this.scheduleForm)
      })
    },
    renderDirectPackage(directData) {
      // 尺寸
      if (directData.deviceSizeList && directData.deviceSizeList.length) {
        this.scheduleForm.deviceSizeData = this.handleReviewSizeData(
          directData.deviceSizeList
        )
        this.backupSize = this.scheduleForm.deviceSizeData
      }
      // 设备、视频源
      this.getBrandList().then(() => {
        if (directData.devices && directData.devices) {
          this.handleReviewDevice(directData.devices)
        }
      })
      // 自定义标签
      if (directData.customMacTagList && directData.customMacTagList.length) {
        this.scheduleForm.customTagType = 1
        this.scheduleForm.macTags = handleReviewPannelData(
          this.macTagList,
          directData.customMacTagList
        )
        this.scheduleForm.customMatchRule =
          directData.customMatchRule === 'notin' ? 'notin' : 'in'
      } else if (directData.customLbsList && directData.customLbsList.length) {
        this.scheduleForm.customTagType = 3
        this.scheduleForm.lbsTags = handleReviewPannelData(
          this.lbsTagList,
          directData.customLbsList
        )
        this.scheduleForm.customMatchRule =
          directData.customMatchRule === 'notin' ? 'notin' : 'in'
      }
      // DMP标签
      if (directData.adScheduleDmps && directData.adScheduleDmps.length) {
        this.scheduleForm.dmpMatchType = directData.adScheduleDmps[0].matchType
        this.scheduleForm.policyId = directData.adScheduleDmps[0].policyId
        this.scheduleForm.policyName = directData.adScheduleDmps[0].policyName
        this.getCrowdList(directData.adScheduleDmps[0].policyId).then((res) => {
          this.scheduleForm.dmpTags = handleReviewDmp(
            this.dmpTagList,
            directData.adScheduleDmps
          )
        })
      }
      this.scheduleForm.crowdMatchType = directData.crowdMatchType || -1
      // 广告DMP
      if (directData.adScheduleCrowds && directData.adScheduleCrowds.length) {
        // this.scheduleForm.crowdMatchType = directData.adScheduleCrowds[0].matchType
        this.scheduleForm.crowdMatchType = directData.crowdMatchType
        this.crowdEchoData = []
        this.crowdIdList = []
        this.scheduleForm.crowdList = directData.adScheduleCrowds.map((item) => {
          this.crowdEchoData.push({
            value: item.crowdTagId,
            label: item.crowdName,
            ...item
          })
          this.crowdIdList.push(item)
          return {
            crowdTagId: item.crowdTagId,
            crowdName: item.crowdName,
            matchType: item.matchType
          }
        })
      }
      // 业务定向
      this.scheduleForm.businessList = directData.adScheduleBusinessSettings || []
      this.handleBusiness()
      // 三方DMP
      this.dmpComponentList = directData.thirdDmpEntityList || []
      this.thirdDmpId = this.dmpComponentList.length ? this.dmpComponentList[0].dmpId : -1
      this.handleThirdDmp()
    },
    getRecStreamList() {
      this.$service
        .getRecStreamList({ sort: 'createTime', order: 'desc' })
        .then((res) => {
          this.recStreamOptions = (res || []).map((item) => {
            return {
              ...item,
              value: item.recId,
              label: item.recName
            }
          })
        })
    },
    handleSetOldForm() {
      this.handleScheduleForm('no').then((data) => {
        this.oldScheduleForm = data
        // 获取编辑时候数据，一下数据修改需要重新送审
        this.oldNeedSubmitObj = {
          payment: this.oldScheduleForm.payment,
          dateType: this.oldScheduleForm.dateType,
          timeList: this.oldScheduleForm.timeList,
          frequency: this.oldScheduleForm.frequency,
          trafficDaily: this.oldScheduleForm.trafficDaily,
          homeDeWeight: this.oldScheduleForm.homeDeWeight,
          totalTraffic: this.oldScheduleForm.totalTraffic,
          regionDailyList: this.oldScheduleForm.regionDailyList,
          macList: this.oldScheduleForm.adScheduleMacs,
          regionList: this.oldScheduleForm.adScheduleRegions
        }
      })
    },
    handleReviewSizeData(data) {
      // 这里要回显尺寸，不等于接口的尺寸，就是自定义
      if (data.length === 0) {
        // 没有尺寸就是不限
        return '-1'
      } else if (data[0].dictSort === 0) {
        const sizeValue = data[0].dictValue.split('-')
        this.scheduleForm.minSize = sizeValue[0]
        this.scheduleForm.maxSize = sizeValue[1]
        return '0'
      } else {
        return data[0].dictValue
      }
    },
    handleReviewDevice(data) {
      if (data) {
        let devices = data
        this.scheduleForm.brandList = handleReviewPannelData(
          this.availableBrandList,
          devices
        )
        this.scheduleForm.videoSource = []
        this.videoSourceList.forEach((item) => {
          devices.forEach((element) => {
            if (item.value === element) {
              this.scheduleForm.videoSource.push(element)
            }
          })
        })
        if (this.scheduleForm.brandList.length > 0) {
          this.scheduleForm.brandType = 1
        }
        // 如果没有选择视频源默认不限
        if (this.scheduleForm.videoSource.length === 0) {
          this.scheduleForm.videoSource = [0]
        }
      }
    },
    // 取消、保存、提交锁量
    handleClickType(type) {
      this.btnType = type
      this.formButtonObj[type].method()
    },
    handleCancel() {
      this.handleScheduleForm().then((data) => {
        this.newScheduleForm = data
        if (this.mode === 'create') {
          this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
            confirmButtonText: '离开页面',
            cancelButtonText: '留在页面',
            center: true,
            type: 'warning'
          })
            .then(() => {
              this.$emit('go-back')
            })
            .catch(() => {})
        } else {
          const isChange = this.$consts.difference(
            this.newScheduleForm,
            this.oldScheduleForm
          )
          if (Object.keys(isChange).length === 0) {
            this.$emit('go-back')
          } else {
            this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
              confirmButtonText: '离开页面',
              cancelButtonText: '留在页面',
              center: true,
              type: 'warning'
            })
              .then(() => {
                this.$emit('go-back')
              })
              .catch(() => {})
          }
        }
      })
    },
    // 保存并关闭,回到列表页
    handleSaveClose() {
      this.handleFormChecked().then((res) => {
        this.handleScheduleForm().then((obj) => {
          this.formButtonObj[this.btnType].loading = true
          const formData = obj
          const serviceType = this.mode === 'create' ? 'SaveNewSchedule' : 'editSchedule'
          this.$service[serviceType](formData, '保存成功')
            .then((data) => {
              this.formButtonObj[this.btnType].loading = false
              this.$emit('go-back')
            })
            .catch(() => {
              this.formButtonObj[this.btnType].loading = false
            })
        })
      })
    },
    // 判断是否需要重新送审
    handleNeedNewSubmit(obj) {
      const newNeedSubmitObj = {
        payment: obj.payment,
        dateType: obj.dateType,
        timeList: obj.timeList,
        frequency: obj.frequency,
        trafficDaily: obj.trafficDaily,
        homeDeWeight: obj.homeDeWeight,
        totalTraffic: obj.totalTraffic,
        regionDailyList: obj.regionDailyList,
        macList: obj.macList,
        regionList: obj.regionList
      }
      const isChange = this.$consts.difference(newNeedSubmitObj, this.oldNeedSubmitObj)
      return Object.keys(isChange).length > 0
    },
    // 提交送审,重新提交送审，变成待审核状态
    handleSubmitAudit() {
      this.handleFormChecked().then((res) => {
        this.handleScheduleForm().then((obj) => {
          let formData = obj
          formData.clockAmountFlag = 1
          this.formButtonObj[this.btnType].loading = true
          this.$service
            .editSchedule(formData, '保存成功')
            .then((data) => {
              this.formButtonObj[this.btnType].loading = false
              this.$emit('go-back')
            })
            .catch(() => {
              this.formButtonObj[this.btnType].loading = false
            })
        })
      })
    },
    // 保存并添加素材（送审）
    handleSaveAuditAndEditMedia() {
      this.handleFormChecked().then((res) => {
        this.handleScheduleForm().then((obj) => {
          let formData = obj
          formData.clockAmountFlag = 1
          this.handleGoMedia(formData, true)
        })
      })
    },
    // 送审并编辑素材 重新审核又分2种情况
    handleSubmitAndEditMeida() {
      this.handleFormChecked().then((res) => {
        this.handleScheduleForm().then((obj) => {
          let formData = obj
          // 只有改了需要送审的才送审
          if (this.handleNeedNewSubmit(obj)) {
            formData.clockAmountFlag = 1
          } else {
            formData.clockAmountFlag = 0
          }
          this.handleGoMedia(formData)
        })
      })
    },
    // 提交后跳转素材创意
    handleGoMedia(formData) {
      this.formButtonObj[this.btnType].loading = true
      const serviceType = this.mode === 'create' ? 'SaveNewSchedule' : 'editSchedule'
      this.$service[serviceType](formData, '保存成功')
        .then((data) => {
          this.formButtonObj[this.btnType].loading = false
          const mediaForm = {
            orderName: this.order.orderName,
            scheduleName: formData.scheduleName,
            scheduleId: this.mode === 'create' ? data.scheduleId : formData.scheduleId,
            scheduleSource: formData.scheduleSource,
            supportMode: formData.supportMode,
            partnerId: this.order.partnerId,
            spaceNo: this.spaceNo,
            spaceId: formData.spaceId,
            recId: this.spaceNo === 'CCADTV10036' ? this.scheduleForm.recId : undefined
          }
          this.$emit('add-media', mediaForm)
        })
        .catch(() => {
          this.formButtonObj[this.btnType].loading = false
        })
    },
    handleFormChecked() {
      const validateArr = []
      if (this.scheduleForm.trafficType === 4) {
        this.handleChangeDailyTraffic()
      }
      // 整个表单校验
      validateArr.push(
        new Promise((resolve, reject) => {
          this.$refs.scheduleForm.validate((valid) => {
            if (valid) {
              resolve(true)
            } else {
              setTimeout(() => {
                const errorDiv = document.getElementsByClassName('is-error')
                errorDiv[0] && errorDiv[0].scrollIntoView()
              }, 0)
            }
          })
        })
      )
      // 曝光频次占比校验
      this.$refs.PvFrequency &&
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.PvFrequency.$refs.form.validate((valid) => {
              if (valid) {
                resolve(true)
              } else {
                setTimeout(() => {
                  const errorDiv = document.getElementsByClassName('is-error')
                  errorDiv[0] && errorDiv[0].scrollIntoView()
                }, 0)
              }
            })
          })
        )
      // 三方dmp定向校验
      this.$refs.thirdDmp &&
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.thirdDmp.$refs.form.validate((valid) => {
              if (valid) resolve(true)
            })
          })
        )
      // 业务定向校验
      this.$refs.bussiness &&
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.bussiness.$refs.form.validate((valid) => {
              if (valid) resolve(true)
            })
          })
        )
      // mac定向校验
      this.$refs.mac &&
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.mac.$refs.macForm.validate((valid) => {
              if (valid) resolve(true)
            })
          })
        )
      // 扩展参数校验
      this.$refs.extendParam &&
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.extendParam.$refs.paramForm.validate((valid) => {
              if (valid) resolve(true)
            })
          })
        )

      return Promise.all(validateArr)
    },
    // 表单提交数据处理
    handleScheduleForm(val) {
      const paramList = (this.extendParamList || []).map((item) => {
        return {
          key: item.key,
          value: item.value
        }
      })
      const extendParams = {
        paramsArray: paramList,
        template: this.template
      }
      const unionFreqList = (this.selectTable.data || []).map((item) => {
        return {
          scheduleId: item.scheduleId,
          scheduleNo: item.scheduleNo,
          unionSeq: item.unionSeq
        }
      })
      const scheduleTaUv = {
        scheduleTaUvId: this.scheduleForm.scheduleTaUvId,
        orderId: this.order.orderId,
        scheduleId: this.scheduleForm.scheduleId,
        taStatus: this.scheduleTaUvKpi.includes('TA') ? 1 : 0,
        uvStatus: this.scheduleTaUvKpi.includes('N+UV') ? 1 : 0,
        uvTarget: this.scheduleTaUvKpi.includes(0)
          ? null
          : this.scheduleForm.uvTarget || null,
        uvPercentage: this.scheduleTaUvKpi.includes(0)
          ? null
          : this.scheduleForm.uvPercentage || null,
        taCondition: this.scheduleTaUvKpi.includes(0)
          ? null
          : this.scheduleForm.taCondition,
        crowdTagId: this.scheduleForm.crowdTagId
      }
      let uvRateList = []
      if (this.scheduleForm.uvRateList && this.scheduleForm.uvRateList.length) {
        if (this.scheduleTaUvKpi.includes(0) || this.scheduleForm.pvRatioType === 0) {
        } else {
          uvRateList = this.scheduleForm.uvRateList.map((it) => {
            return {
              minFrequency: it.uvMatch === 0 ? it.frequency : it.minFrequency,
              maxFrequency: it.uvMatch === 0 ? it.frequency : it.maxFrequency,
              uvMatch: it.uvMatch,
              uvPercentage: it.uvPercentage
            }
          })
        }
      }
      return new Promise((resolve, reject) => {
        const form = {
          adScheduleVideoTags:
            this.scheduleForm.mediaTags.length > 0
              ? handleFormMediaTags(this.scheduleForm.mediaTags)
              : undefined,
          autoFilling: this.scheduleForm.autoFilling,
          businessSettingList:
            this.scheduleForm.businessList.length > 0
              ? this.handleFormBussiness(this.scheduleForm.businessList)
              : undefined,
          channelId: this.scheduleForm.channelId,
          clockAmountFlag: 0, // 锁量标示
          customLbsList:
            this.scheduleForm.customTagType === 3
              ? this.handleFormTags(this.scheduleForm.lbsTags)
              : undefined,
          customMacTagList:
            this.scheduleForm.customTagType === 1
              ? this.handleFormTags(this.scheduleForm.macTags)
              : undefined,
          customMatchRule: this.scheduleForm.customMatchRule,
          dateType: this.scheduleForm.dateType,
          deviceSizeList: this.handleFormDeviceSizeList(this.scheduleForm.deviceSizeData),
          devices: this.handleFormDevices(),
          dmpList: this.handleFormDmpList(),
          frequency: this.scheduleForm.frequency,
          homeDeWeight: this.iqyCableChannel ? undefined : this.scheduleForm.homeDeWeight,
          macList: this.handleFormMacList(),
          orderId: this.order.orderId,
          payment: this.scheduleForm.payment,
          planType: this.scheduleForm.planType,
          dealId: this.scheduleForm.dealId ? this.scheduleForm.dealId : undefined,
          payTotalTraffic:
            this.scheduleForm.trafficType === 2
              ? this.handleFormTraffic(this.scheduleForm.payTraffic)
              : undefined,
          freeTotalTraffic:
            this.scheduleForm.trafficType === 2
              ? this.handleFormTraffic(this.scheduleForm.freeTraffic)
              : undefined,
          addedTotalTraffic:
            this.scheduleForm.trafficType === 2
              ? this.handleFormTraffic(this.scheduleForm.addedTraffic)
              : undefined,
          payDailyList:
            this.scheduleForm.trafficType === 4
              ? handleFormRegionDaily(this.dailyTrafficTable, 'payTotalTraffic')
              : [],
          freeDailyList:
            this.scheduleForm.trafficType === 4
              ? handleFormRegionDaily(this.dailyTrafficTable, 'freeTotalTraffic')
              : [],
          addedDailyList:
            this.scheduleForm.trafficType === 4
              ? handleFormRegionDaily(this.dailyTrafficTable, 'addedTotalTraffic')
              : [],
          regionDailyList:
            this.scheduleForm.trafficType === 4
              ? handleFormRegionDaily(this.dailyTrafficTable, 'totalTraffic')
              : [],
          regionList: this.handleFormRegionList(this.scheduleForm.regionList),
          saleType: this.scheduleForm.saleType,
          scheduleUnionList:
            this.scheduleForm.unionSequence === 0 ? undefined : unionFreqList,
          scheduleId: this.scheduleForm.scheduleId,
          scheduleName: this.scheduleForm.scheduleName,
          scheduleSource:
            this.scheduleForm.planType === 0 ? 0 : this.scheduleForm.scheduleSource,
          seq: this.scheduleForm.seqType === 0 ? 0 : this.scheduleForm.seq,
          spaceId: this.scheduleForm.spaceId,
          supportMode:
            this.scheduleForm.planType === 0 ? undefined : this.scheduleForm.supportMode,
          timeList: handleFormTimeList(this.scheduleForm.putTimeList),
          totalTraffic: this.handleFormTraffic(this.scheduleForm.totalTraffic),
          trafficDaily: parseInt(this.scheduleForm.trafficDaily || 0),
          trafficSpeed: this.scheduleForm.trafficSpeed,
          pvRate: this.pvRateType === 1 ? this.scheduleForm.pvRate : '',
          trafficType: this.scheduleForm.trafficType,
          unionSequence: this.scheduleForm.unionSequence,
          unionFreq:
            this.scheduleForm.unionSequence === 0
              ? undefined
              : this.scheduleForm.unionFreq,
          subUnionFreq:
            this.scheduleForm.unionSequence === 0 || this.scheduleForm.subFrequency === 1
              ? undefined
              : this.scheduleForm.subUnionFreq,
          cableChannelList: this.scheduleForm.cableChannelList,
          subFrequency: this.scheduleForm.subFrequency,
          subTrafficDaily:
            this.scheduleForm.subFrequency === 1
              ? 0
              : parseInt(this.scheduleForm.subTrafficDaily || 0),
          sellingPrice: this.scheduleForm.sellingPrice,
          billType: this.order.sellingType,
          dmpMatchType:
            this.scheduleForm.dmpMatchType === -1
              ? undefined
              : this.scheduleForm.dmpMatchType,
          receivePct: this.scheduleForm.receivePct,
          exposurePct: this.exposurePctType === 0 ? 0 : this.scheduleForm.exposurePct,
          extendParams:
            this.extendParamType === 1 ? JSON.stringify(extendParams) : undefined,
          ctr: this.showCtr && this.ctrType === 1 ? parseInt(this.scheduleForm.ctr) : 0,
          thridDmpList:
            this.thirdDmpId === -1
              ? []
              : this.handleFormBussiness(this.dmpComponentList, 'dmp'),
          crowdMatchType:
            this.scheduleForm.crowdMatchType === -1
              ? undefined
              : this.scheduleForm.crowdMatchType,
          crowdList:
            this.scheduleForm.crowdMatchType === -1 ||
            !this.showOtherDirections ||
            !this.isOwn
              ? []
              : this.scheduleForm.crowdList,
          erpSubOrder:
            this.erpModeSwitch === 1 ? this.scheduleForm.erpSubOrder : undefined,
          suborderNo: this.erpModeSwitch === 2 ? this.scheduleForm.suborderNo : undefined,
          directPackageSave: this.scheduleForm.directPackageSave,
          directPackageName:
            this.showOtherDirections && this.scheduleForm.directPackageSave === 1
              ? this.scheduleForm.directPackageName
              : undefined,
          scheduleTaUv: scheduleTaUv,
          scheduleSub: {
            exposureDirectly: this.showExposureDirectly
              ? this.scheduleForm.exposureDirectly
              : undefined,
            recId: this.spaceNo === 'CCADTV10036' ? this.scheduleForm.recId : undefined,
            checkExposurePct:
              this.exposurePctType === 2 ? this.scheduleForm.checkExposurePct : 0,
            addExposurePct:
              this.exposurePctType === 2 ? this.scheduleForm.addExposurePct : 0
          },
          uvRateList: this.scheduleForm.pvRatioType === 1 ? uvRateList : [],
          iesSwitch: this.scheduleForm.iesSwitch
        }
        // 判断关联频控次数与计划单频次是否一致
        let ln = this.selectTable.data.find(
          (item) => item.trafficDaily !== parseInt(this.scheduleForm.unionFreq || 0)
        )
        // 判断关联频控次数与计划单频次是否一致
        if (
          val !== 'no' &&
          this.scheduleForm.unionSequence !== 0 &&
          this.scheduleForm.unionSequence === 2 &&
          (ln ||
            parseInt(this.scheduleForm.trafficDaily) !==
              parseInt(this.scheduleForm.unionFreq))
        ) {
          this.$confirm('关联频控次数与计划单频次不一致，是否确认保存提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve(form)
          })
        } else {
          resolve(form)
        }
      })
    },
    // 处理要提交的业务定向数据
    handleFormBussiness(data = [], type) {
      const { buildBusinessValue } = useSpaceComponent()
      const result = data
        .map((item) => {
          return {
            componentId: item.componentId,
            componentKey: item.componentKey,
            componentType: item.componentType,
            componentMatchType: item.componentMatchType,
            componentValue: buildBusinessValue(item),
            dmpId: type === 'dmp' ? this.thirdDmpId : undefined,
            scheduleId:
              type === 'dmp' && this.scheduleForm.scheduleId
                ? this.scheduleForm.scheduleId
                : undefined
          }
        })
        .filter((e) => e.componentValue)
      return result
    },
    // 处理自定义标签
    handleFormTags(data) {
      if (!this.showOtherDirections || !data.length) return undefined
      return data.map((item) => item.value)
    },
    // 处理尺寸定向
    handleFormDeviceSizeList(data) {
      if (!this.showOtherDirections || data === '-1') return undefined
      return data === '0'
        ? [
          {
            dictSort: 0,
            dictValue: `${this.scheduleForm.minSize}-${this.scheduleForm.maxSize}`
          }
        ]
        : [
          {
            dictSort: this.deviceSizeList.find((item) => item.value === data).dictSort,
            dictValue: data
          }
        ]
    },
    handleFormDevices() {
      if (!this.showOtherDirections) return []
      let devicesData = this.scheduleForm.videoSource.filter((item) => item && item !== 0)
      this.scheduleForm.brandList.forEach((item) => {
        devicesData.push(item.value)
      })
      return devicesData
    },
    handleFormDmpList() {
      if (!this.showOtherDirections) return []
      return this.scheduleForm.dmpTags.map((item) => {
        return {
          policyId: this.scheduleForm.policyId,
          policyName: this.scheduleForm.policyName,
          crowdId: item.value,
          text: item.label
        }
      })
    },
    handleFormMacList() {
      this.scheduleForm.macList.forEach((item) => {
        item.endMac = item.beginMac
      })
      return (this.scheduleForm.macList || []).filter(
        (item) => item.beginMac && item.endMac
      )
    },
    handleFormRegionList(data) {
      if (!this.showOtherDirections) return []
      return data.map((item) => {
        return {
          parent: item.children ? 0 : item.value.toString().substring(0, 2),
          region: item.value,
          name: item.label
        }
      })
    },
    handleFormTraffic(data) {
      if (this.scheduleForm.trafficType === 1) {
        return 0
      } else {
        if (this.scheduleForm.trafficUnit === 0) {
          return stringToInt(data) * 1000
        } else {
          return stringToInt(data)
        }
      }
    },
    handleTrafficDailyInput(val) {
      if (!val) return
      // 有序关联频控，所有计划单频次之和
      if (this.scheduleForm.unionSequence === 1) {
        let uninFreq = this.scheduleForm.trafficDaily * 1
        this.selectTable.data.forEach((item) => {
          if (this.scheduleForm.scheduleId !== item.scheduleId) {
            uninFreq += item.trafficDaily
          } else {
            item.trafficDaily = this.scheduleForm.trafficDaily * 1
          }
        })
        this.scheduleForm.unionFreq = uninFreq
      }
    },
    handleSubTrafficDailyInput(val) {
      if (!val) return
      // 有序关联频控，所有计划单双周期频次之和
      if (this.scheduleForm.unionSequence === 1) {
        let subUnionFreq = this.scheduleForm.subTrafficDaily * 1
        this.selectTable.data.forEach((item) => {
          if (this.scheduleForm.scheduleId !== item.scheduleId) {
            subUnionFreq += item.subTrafficDaily
          } else {
            item.subTrafficDaily = this.scheduleForm.subTrafficDaily * 1
          }
        })
        this.scheduleForm.subUnionFreq = subUnionFreq
      }
    },
    handleCleanAllSelectTable(val) {
      this.selectTable.data = []
      if (this.scheduleForm.unionSequence === 1) {
        this.scheduleForm.unionFreq = this.scheduleForm.trafficDaily
        this.scheduleForm.subUnionFreq = this.scheduleForm.subTrafficDaily
      }
    },
    handleUnionScheduleConfirm(data) {
      let newObj = {}
      let uninFreq = (this.scheduleForm.trafficDaily || 0) * 1
      let subUnionFreq = (this.scheduleForm.subTrafficDaily || 0) * 1
      const isUniqueData = this.selectTable.data.concat(data).reduce((cur, next) => {
        // eslint-disable-next-line
        newObj[next.scheduleNo] ? '' : (newObj[next.scheduleNo] = true && cur.push(next))
        return cur
      }, [])
      this.selectTable.data = isUniqueData.map((item) => {
        if (this.scheduleForm.scheduleId !== item.scheduleId) {
          uninFreq += item.trafficDaily
          subUnionFreq += item.subTrafficDaily
        }
        return {
          unionSeq: item.unionSeq,
          subUnionFreq: item.subUnionFreq,
          scheduleNo: item.scheduleNo,
          scheduleName: item.scheduleName,
          scheduleStatus: item.scheduleStatus,
          trafficDaily: item.trafficDaily,
          frequency: item.frequency,
          subTrafficDaily: item.subTrafficDaily,
          subFrequency: item.subFrequency,
          scheduleId: item.scheduleId,
          disabled: false,
          seqDisabled: this.scheduleForm.unionSequence === 2
        }
      })
      // 有序关联频控的频控等于所有计划单频控之和，且不可更改
      if (this.scheduleForm.unionSequence === 1) {
        this.scheduleForm.unionFreq = uninFreq
        this.scheduleForm.subUnionFreq = subUnionFreq
      }
    },
    // 修改频控提示
    handleChangeFrequency(val) {
      if (
        this.mode === 'edit' &&
        this.selectTable.data.length > 0 &&
        !this.triggerDialogFormStatus.frequency
      ) {
        this.$confirm('修改频控条件将清空已选的关联频控单，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.scheduleForm.frequency = val
            this.triggerDialogFormStatus.frequency = true
            // 修改频次控制后，需要初始化双周期和关联频控
            this.handleRestoreSubUnique()
          })
          .catch(() => {
            this.triggerDialogFormStatus.frequency = true
          })
      } else {
        this.scheduleForm.frequency = val
        // 修改频次控制后，需要初始化双周期和关联频控
        this.handleRestoreSubUnique()
      }
      if (val === 1) {
        this.scheduleForm.trafficDaily = undefined
      }
      this.$refs.scheduleForm.validateField('uvCanSelect')
    },
    handleRestoreSubUnique() {
      this.scheduleForm.unionSequence = 0
      this.selectTable.data = []
      this.scheduleForm.unionFreq = undefined
      this.scheduleForm.subUnionFreq = undefined
      this.scheduleForm.subFrequency = 1
      this.scheduleForm.subTrafficDaily = undefined
    },
    // 双周期频控变化
    handleChangeSubfrequency(val) {
      this.scheduleForm.unionSequence = 0
      this.scheduleForm.unionFreq = undefined
      this.scheduleForm.subUnionFreq = undefined
      this.selectTable.data = []
    },
    handleChangePctType(val) {
      if (this.receivePctType === 0) {
        this.scheduleForm.receivePct = this.spacePctRatio
      }
    },
    handleChangeExposurePctType(val) {
      this.scheduleForm.checkExposurePct = undefined
      this.scheduleForm.addExposurePct = undefined
      this.scheduleForm.exposurePct = 0
      this.$refs.scheduleForm.clearValidate()
    },
    calcExposurePct() {
      const checkExposurePct = Number.isInteger(this.scheduleForm.checkExposurePct * 1)
        ? this.scheduleForm.checkExposurePct * 1
        : 0
      const addExposurePct = Number.isInteger(this.scheduleForm.addExposurePct * 1)
        ? this.scheduleForm.addExposurePct * 1
        : 0
      if (this.exposurePctType === 1) {
        this.scheduleForm.exposurePct = checkExposurePct
      } else if (this.exposurePctType === 2) {
        this.scheduleForm.exposurePct = checkExposurePct + addExposurePct
        this.$refs.scheduleForm.validateField('exposurePct')
      }
    },
    handleDeleteSelectTable(data) {
      const index = this.selectTable.data.findIndex(
        (item) => item.scheduleNo === data.scheduleNo
      )
      this.selectTable.data.splice(index, 1)
      if (this.scheduleForm.unionSequence === 1) {
        this.handleTrafficDailyInput(1)
        this.handleSubTrafficDailyInput(1)
      }
    },
    saveBatchAddArea(value) {
      let values = value.map((item) => item.regionId)
      const addRegions = []
      this.regionsData.forEach((item) => {
        if (values.indexOf(item.value) > -1) {
          addRegions.push(item)
        } else if (item.children) {
          item.children.forEach((e) => {
            if (values.indexOf(e.value) > -1) {
              addRegions.push(e)
            }
          })
        }
      })
      const newValues = this.scheduleForm.regionList.map((item) => item.value)
      addRegions.forEach((item) => {
        if (newValues.indexOf(item.value) === -1) {
          this.scheduleForm.regionList.push(item)
          this.$refs.regionPannel.$children[0].handleSelectNode(item)
        }
      })
      this.$refs.popBatchAdd.batchAddOpen = false
    },
    getThirdDmpList() {
      return new Promise((resolve, reject) => {
        const params = { status: 1 }
        this.$service.getThirdDmpList(params).then((res) => {
          this.thirdDmpOptions = res
          resolve()
        })
      })
    },
    handleThirdDmpChange(val) {
      this.dmpComponentList = []
      this.handleThirdDmp(true)
      this.clearPackage()
    },
    handleCrowdSelected(val) {
      this.scheduleForm.crowdList = val.map((item) => {
        return {
          crowdTagId: item.crowdTagId,
          crowdName: item.crowdName,
          crowdSource: item.crowdSource,
          matchType: item.matchType
        }
      })
      this.clearPackage()
    },
    handleJumpToDmp() {
      if (this.$store.state.dmpUrl) {
        window.open(this.$store.state.dmpUrl)
      }
    },
    // 根据条件获取媒体方
    getCableChannel(showDefault = true) {
      if (this.spaceNo === '' || this.scheduleForm.channelId === '') {
        return
      }
      // planType 是否支持程序化0, 1
      const params = {
        orderId: this.order.orderId,
        spaceNo: this.spaceNo,
        planType: this.scheduleForm.planType,
        channelId: this.scheduleForm.channelId
      }
      this.$service.getCableChannel(params).then((data) => {
        this.cableChannelList = (data || []).map((item) => {
          return {
            label: item.cableName,
            value: item.cableNo,
            selectBox: item.selectBox // 1默认勾选
          }
        })
        // 默认勾选媒体方
        showDefault && this.handleSetcableChannel()
      })
    },
    // 选择的机型标签回显到品牌机型、区域、尺寸、视频源定向
    setCustomTagDirect(tagId) {
      const customTag = this.customTagList.find((item) => item.adCustomTagId === tagId)
      if (!customTag) {
        return
      }
      this.directPackageId = ''
      if (customTag.regionList && customTag.regionList.length) {
        const regionKeyObj = this.directinal.regionList.reduce((prev, cur) => {
          prev[cur.regionId] = cur
          return prev
        }, {})
        this.scheduleForm.areaType = 1
        const regionList = []
        this.scheduleForm.regionList = []
        customTag.regionList.forEach((item) => {
          const hasPermission = regionKeyObj[item.id]
          if (hasPermission) {
            regionList.push({
              value: item.id,
              label: item.name
            })
          }
        })
        this.scheduleForm.regionList = regionList
      }
      if (customTag.modelList && customTag.modelList.length) {
        const brandKeyObj = this.brandsModelsList.reduce((prev, cur) => {
          prev[cur.tagDeviceId] = cur.tag
          return prev
        }, {})
        const brandList = []
        this.scheduleForm.brandType = 1
        this.scheduleForm.brandList = []
        customTag.modelList.forEach((item) => {
          const hasPermission = brandKeyObj[item.id]
          if (hasPermission) {
            brandList.push({
              value: item.id,
              label: item.name
            })
          }
        })
        this.scheduleForm.brandList = brandList
      }
      if (customTag.size) {
        const sizeExist = this.deviceSizeList.find(
          (item) => item.value === customTag.size
        )
        if (sizeExist) {
          this.scheduleForm.deviceSizeData = customTag.size
        } else {
          this.scheduleForm.deviceSizeData = '0'
          this.scheduleForm.minSize = customTag.size.split('-')[0]
          this.scheduleForm.maxSize = customTag.size.split('-')[1]
        }
      }
      if (customTag.tvSources && customTag.tvSources.length) {
        this.scheduleForm.videoSource = customTag.tvSources
      }
      this.$nextTick(() => {
        this.customTag = tagId
      })
    },
    // 选择了定向包
    setDirectPackage(val) {
      if (!val) {
        return
      }
      this.customTag = ''
      this.$service.getDirectPackageDetail({ directPackageId: val }).then((res) => {
        this.renderDirectPackage(res.packageDetailData || {})
      })
    },
    // 获取业财合规化开关
    getErpModeSwitch() {
      this.$service.getErpModeSwitch().then((res) => {
        this.erpModeSwitch = res ? parseInt(res) : 0
        if (res === '2') {
          this.getSalesSubOrderList()
        }
      })
    },
    getSalesSubOrderList() {
      this.$service.getSalesSubOrders({ id: this.order.orderId }).then((res) => {
        this.subOrderOptions = res || []
      })
    },
    // 选择ERP订单
    handleSelectErpOrder(row) {
      this.scheduleForm.erpSubOrder = row.subOrder
      this.scheduleForm.erpOrderName = row.subOrderName
      this.scheduleForm.sellingPrice = row.settlePrice
      this.mediaTimes = row.materialEntity
        ? parseInt(row.materialEntity.showTime)
        : undefined
      // 广告位：必须在已关联ERP订单中产品里面限定的广告位中选择
      this.supportedSpaceNos =
        row.materialEntity.spaceNo === '0' ? [] : row.materialEntity.spaceNo.split(',')
      this.scheduleForm.spaceId = undefined
      // 如果关联ERP订单，只能选择正常结算
      if (this.scheduleForm.payment !== undefined && this.scheduleForm.payment !== 0) {
        this.scheduleForm.payment = 0
      }
      // 订单不是CPD
      if (this.order.sellingType !== 3 && this.scheduleForm.trafficType === 1) {
        this.scheduleForm.trafficType = 4
      }
    },
    handleChangeSubOrder(val) {
      if (val) {
        const subOrder = this.subOrderOptions.find((item) => item.suborderNo === val)
        this.supportedSpaceNos = [subOrder.spaceNo]
        this.scheduleForm.spaceId = subOrder.spaceId
        this.scheduleForm.sellingPrice = subOrder.settlePrice
        this.handelChangeSpaceImpact(subOrder.spaceId)
      } else {
        this.supportedSpaceNos = []
        this.scheduleForm.sellingPrice = 0
      }
    },
    // 清除
    clearErpOrder() {
      this.scheduleForm.erpSubOrder = ''
      this.scheduleForm.erpOrderName = ''
      this.mediaTimes = undefined
      this.scheduleForm.sellingPrice = 0
      this.supportedSpaceNos = []
      if (this.scheduleForm.payDailyTraffic) {
        this.scheduleForm.payDailyTraffic = ''
      }
      if (this.scheduleForm.payTraffic) {
        this.scheduleForm.payTraffic = ''
      }
    },
    getBaseDict() {
      this.$service.getBaseDict().then((res) => {
        this.pvRateOptions = (res.pvRateList || []).map((item) => {
          return {
            value: item.dictValue,
            label: item.dictLabel
          }
        })
      })
    },
    handleTrafficSpeedChange() {
      if (this.scheduleForm.trafficSpeed === 1) {
        this.pvRateType = 0
        this.scheduleForm.pvRate = ''
      }
    },
    handleDealIdTypeChange(val) {
      if (val === 0) {
        this.scheduleForm.dealId = this.scheduleForm.scheduleNo || ''
        return
      }
      this.scheduleForm.dealId = ''
    },
    handleChangeOrder(orders) {
      if (orders.length === 0) return
      this.order.orderId = orders[0].orderId
      this.order.orderNo = orders[0].orderNo
      this.order.orderName = orders[0].orderName
      this.order.partnerId = orders[0].partnerId
      this.order.sellingType = orders[0].sellingType
      this.order.contractBeginDate = orders[0].contractEndDate
      this.order.contractEndDate = orders[0].contractEndDate
      this.scheduleForm.partnerId = orders[0].partnerId
      this.scheduleForm.billType = orders[0].sellingType
      if (this.erpModeSwitch === 2) {
        this.scheduleForm.suborderNo = ''
        this.getSalesSubOrderList()
      }
    }
  },
  mounted() {},
  created() {
    this.isMac = detectOS()
    this.getBaseDict()
    this.handleFetch()
    this.getErpModeSwitch()
  }
}
</script>
<style lang="stylus" src="./AdCommonForm.styl" scoped></style>
<style>
.popper-option__tail {
  color: #c0c4cc;
}

.el-select-dropdown__item.selected .popper-option__tail {
  color: #ff8b00;
}
</style>
